import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const GERMAN = {
  type: 'de-DE',
  languageNames: {
    en: 'Englisch',
    no: 'Norwegisch',
    nb: 'Norwegisch',
    de: 'Deutsch',
    fr: 'Französisch',
    sv: 'Schwedisch',
    se: 'Schwedisch',
    da: 'Dänisch',
    it: 'Italienisch',
    fi: 'Finnisch',
  },
  global: {
    noDataAvailable: 'Keine Daten verfügbar',
    move: 'Verschieben',
    rotate: 'Drehen',
    model: 'Modell',
    data: 'Daten',
    all: 'Alle',
    controls: 'Steuerung',
    lastUpdated: 'Zuletzt aktualisiert',
    noData: 'Keine Daten',
    custom: 'Benutzerdefiniert',
    name: 'Name',
    setpoints: 'Setpunkte',
    email: 'E-Mail',
    date: 'Datum',
    timestamp: 'Zeitstempel',
    device: 'Gerät',
    devices: 'Geräte',
    language: 'Sprache',
    timezone: 'Zeitzone',
    address: 'Adresse',
    street: 'Straße',
    postcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    new: 'Neu',
    from: 'Von',
    until: 'Bis',
    selectStartDate: 'Startdatum wählen',
    selectEndDate: 'Enddatum wählen',
    copied: 'Kopiert',
    average: 'Durchschnitt',
    min: 'Min',
    max: 'Max',
    last: 'Letzter',
    type: 'Typ',
    role: 'Rolle',
    category: 'Kategorie',
    description: 'Beschreibung',
    status: 'Status',
    public: 'Öffentlich',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiviert',
    hidden: 'Versteckt',
    visible: 'Sichtbar',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    disabled: 'Deaktiviert',
    actionRequired: 'Aktion erforderlich',
    success: 'Erfolg',
    none: 'Keine',
    error: 'Fehler',
    basicInfo: 'Grundinformationen',
    information: 'Informationen',
    display: 'Anzeige',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    saveSuccess: 'Gespeichert',
    saveError: 'Speichern fehlgeschlagen',
    search: 'Suchen',
    close: 'Schließen',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    cancel: 'Abbrechen',
    update: 'Aktualisieren',
    updating: 'Wird aktualisiert...',
    undo: 'Rückgängig',
    done: 'Fertig',
    delete: 'Löschen',
    discard: 'Verwerfen',
    rename: 'Umbenennen',
    editName: 'Name bearbeiten',
    download: 'Herunterladen',
    open: 'Öffnen',
    password: 'Passwort',
    login: 'Anmelden',
    loginWithAzure: 'Mit Azure anmelden',
    invalidCredentials: 'Ungültige Anmeldedaten',
    loginTooManyAttempts:
      'Zu viele Anmeldeversuche, bitte versuchen Sie es in einigen Minuten erneut',
    loginInactiveUser: 'Dieses Benutzerkonto ist nicht mehr aktiv',
    loginUnavailable:
      'Anmeldung derzeit nicht möglich, bitte versuchen Sie es später erneut',
    welcome: 'Willkommen bei Sastech',
    loginSubtitle: 'Melden Sie sich an, um auf Ihr Dashboard zuzugreifen',
    or: 'oder',
    key: 'Schlüssel',
    back: 'Zurück',
    add: 'Hinzufügen',
    apply: 'Anwenden',
    inDevelopment: 'In Entwicklung',
    notAuthorized: 'Nicht autorisiert',
    heating: 'Heizung',
    cooling: 'Kühlung',
    ventilation: 'Belüftung',
    climate: 'Raumklima',
    battery: 'Batterie',
    batteries: 'Batterien',
    capabilities: 'Fähigkeiten',
    moveTo: 'Verschieben nach',
    building: 'Gebäude',
    buildings: 'Gebäude',
    floor: 'Etage',
    floors: 'Etagen',
    sensors: 'Sensoren',
    sensor: 'Sensor',
    controller: 'Steuerung',
    energySource: 'Energiequelle',
    session: 'Sitzung',
    addDevice: 'Gerät hinzufügen',
    selectDevice: 'Wählen Sie ein Gerät aus',
    serialNumber: 'Seriennummer',
    trash: 'Papierkorb',
    actions: 'Aktionen',
    restore: 'Wiederherstellen',
    emptyTrash: 'Papierkorb leeren',
    selectCategory: 'Auswählen...',
    create: 'Erstellen',
    monthChartText: [
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez',
    ],
    today: 'Heute',
    weekdaysShort: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
    weekdays: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
    title: 'Titel',
    to: 'bis',
    remove: 'Entfernen',
    inspect: 'Inspizieren',
    compare: 'Vergleichen',
    export: 'Exportieren',
    total: 'Gesamt',
    activate: 'Aktivieren',
    color: 'Farbe',
    text: 'Text',
    link: 'Link',
    frame: 'Rahmen',
    info: 'Info',
    saveChanges: 'Änderungen speichern',
    sidebarMenu: 'Seitenleiste',
    icons: 'Symbole',
    ok: 'OK',
    exit: 'Schließen',
    exportImage: 'Bild exportieren',
    exportSelected: 'Auswahl exportieren',
    directions: {
      top: 'Oben',
      bottom: 'Unten',
      right: 'Rechts',
      left: 'Links',
      front: 'Vorne',
      back: 'Hinten',
      isometric: 'Isometrisch',
    },
    switchVendor: 'Kunde wechseln',
    searchVendors: 'Kunden suchen...',
    noVendorsFound: 'Keine Kunden gefunden',
  },
  chart: {
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    rotate: 'Drehen',
    fullscreen: 'Vollbild',
    rotateTip: 'Klicken und ziehen zum Drehen des Diagramms',
  },
  data: {
    loading: 'Laden...',
    loadingData: 'Daten werden geladen...',
    noResults: 'Keine Ergebnisse gefunden.',
    error: 'Fehler',
    failedToLoadData: 'Daten konnten nicht geladen werden',
    noDataAvailable: 'Keine Daten verfügbar',
  },
  general: {
    temperature: 'Temperatur',
    co2: 'CO₂',
    humidity: 'Luftfeuchtigkeit',
    zone: 'Zone',
    data: 'Daten',
    edit: 'Bearbeiten',
    analyze: 'Analysieren',
    chartType: 'Diagrammtyp',
    toggleSeries: 'Serien umschalten',
    resetFilters: 'Filter zurücksetzen',
    exportData: 'Daten exportieren',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Stellen Sie Ihre Frage hier…',
    send: 'Senden',
    unknownUser: 'Unbekannter Benutzer',
  },
  navigation: {
    dashboard: 'Dashboard',
    eosDashboard: 'Übersicht',
    devices: 'Geräte',
    map: 'Karte',
    buildings: 'Gebäude',
    reports: 'Berichte',
    settings: 'Einstellungen',
    logout: 'Abmelden',
    sastech: 'Sastech Einstellungen',
    analytics: 'Analysen',
    buildings3D: 'Gebäude 3D',
    superSettings: 'Sastech',
    buildingInspection: 'Inspektion',
    expandSidebar: 'Seitenleiste erweitern',
    collapseSidebar: 'Seitenleiste einklappen',
    userCalendar: 'Benutzerkalender',
    energyLabelLeads: 'Energiekennzeichnung-Leads',
  },
  reports: {
    title: 'Berichte',
    orderReport: 'Bericht bestellen',
    orderDescription:
      'Der Bericht erscheint in der Liste, sobald er fertig ist.',
    reportType: 'Berichtstyp',
    kinds: {
      eos_weekly: 'Wöchentlicher Energiebericht',
      eos_monthly: 'Monatlicher Energiebericht',
    },
    period: 'Zeitraum',
    week: 'Woche {week}',
    reportLanguage: 'Berichtssprache',
    submit: 'Bestellen',
    submitting: 'Wird bestellt…',
    status: {
      queued: 'In Warteschlange',
      generating: 'Wird erstellt',
      completed: 'Fertig',
      failed: 'Fehlgeschlagen',
    },
    exportExcel: 'Excel herunterladen',
    exportPdf: 'PDF herunterladen',
    makePdf: 'PDF erstellen',
    pdfPending: 'PDF wird erstellt…',
    confirmDeleteTitle: 'Bericht löschen',
    confirmDeleteMessage:
      'Der Bericht wird aus der Liste entfernt. Das lässt sich nicht rückgängig machen.',
    noReports: 'Noch keine Berichte. Bestellen Sie den ersten.',
    noSearchHits: 'Keine Berichte passen zur Suche.',
    noMeters: 'Das Gebäude hat keine aktiven Energiezähler.',
    duplicateOrder: 'Derselbe Bericht wird bereits erstellt.',
    orderError: 'Der Bericht konnte nicht bestellt werden',
    orderSuccess: 'Der Bericht ist bestellt und wird erstellt.',
    deleteError: 'Der Bericht konnte nicht gelöscht werden',
    pdfError: 'Das PDF konnte nicht bestellt werden',
    pdfRequested: 'Das PDF ist bestellt und wird erstellt.',
    requestedBy: 'Bestellt von',
    ordered: 'Bestellt',
    daysAgo: 'vor {count} Tagen',
    sheets: {
      summary: 'Zusammenfassung',
      days: 'Pro Tag',
      hours: 'Pro Stunde',
      sources: 'Zähler',
      profile: 'Tagesprofil',
    },
    excel: {
      parameter: 'Parameter',
      value: 'Wert',
      unit: 'Einheit',
      delivered: 'Gelieferte Energie',
      production: 'Eigenerzeugung',
      export: 'Exportiert',
      net: 'Im Gebäude verbraucht',
      baseline: 'Baseline',
      previousYear: 'Vorjahr',
      co2: 'CO2',
      baselineCo2: 'CO2 Baseline',
      hoursWithData: 'Stunden mit Daten',
      meanKW: 'Mittlere Leistung',
      maxKW: 'Höchste Stunde',
      maxAt: 'Höchste Stunde am',
      baseLoadKW: 'Grundlast',
      nightKW: 'Nachtlast 00–05',
      peakHours: 'Stunden auf oder über 90 % des Maximums',
      weekday: 'Wochentag',
      time: 'Stunde',
      source: 'Zähler',
      missingHours: 'Fehlende Stunden',
      energy: 'Energie',
      co2Factor: 'CO2 Faktor',
      role_delivered: 'gelieferte Energie',
      role_production: 'Eigenerzeugung',
      role_export: 'Export',
      role_excluded: 'nicht gezählt',
    },
  },
  map: {
    addBuildingAtCenter: 'Gebäude in der Kartenmitte hinzufügen',
  },
  pagination: {
    rowsPerPage: 'Zeilen pro Seite',
    rangeSeparator: 'von',
  },
  devices: {
    title: 'Geräteübersicht',
    reset: 'Zurücksetzen',
    noDevices: 'Keine Geräte gefunden.',
    unnamed: 'Unbenanntes Gerät',
    copySensorTag: 'Sensortag kopieren',
    graph: {
      inspect: 'Inspizieren',
      edit: 'Bearbeiten',
      chartType: 'Diagrammtyp',
      toggleSeries: 'Serien umschalten',
      resetFilters: 'Filter zurücksetzen',
      exportData: 'Daten exportieren',
      noData: 'Keine Daten',
      bar: 'Balken',
      line: 'Linie',
      pie: 'Kreis',
      scatter: 'Streuung',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filtern',
      filterByCategory: 'Nach Kategorie filtern',
      selectAll: 'Alle auswählen',
      clearAll: 'Alle löschen',
      searchCategories: 'Kategorien suchen...',
      noCategories: 'Keine Kategorien gefunden',
      noData: 'Keine Daten',
      devices: 'Geräte',
      selected: 'Ausgewählt',
      category: 'Kategorie',
      categories: 'Kategorien',
      more: 'weitere',
    },
    detailLevel: {
      label: 'Detailebene',
      units: {
        minutes: 'Minuten',
        minutesShort: 'Min.',
        day: 'Tag',
      },
    },
    dateRange: {
      startLabel: 'Startdatum',
      endLabel: 'Enddatum',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Datum',
        total: {
          production: 'Gesamtproduktion:',
          consumption: 'Gesamtverbrauch:',
        },
        highestPeak: 'Höchster Spitzenwert:',
        calculatedPrice: {
          eur: 'Berechneter Preis (EUR):',
          nok: 'Berechneter Preis (NOK):',
        },
      },
    },
  },
  analytics: {
    session: {
      moreActions: 'Weitere Aktionen',
      newSession: 'Neue Sitzung',
      unsaved: 'Nicht gespeicherte Änderungen',
      namePlaceholder: 'Sitzungsname',
      deleteTitle: 'Sitzung löschen?',
      deleteDescription:
        'Damit werden die gespeicherte Sitzung und ihre Geräteauswahl dauerhaft entfernt.',
      noSessions: 'Keine gespeicherten Sitzungen',
      discardTitle: 'Nicht gespeicherte Änderungen verwerfen?',
      discardDescription:
        'Die aktuelle Sitzung hat Änderungen, die nicht gespeichert wurden. Beim Wechseln gehen sie verloren.',
    },
    notifications: {
      overlayMissingZone:
        'Für das Gebäude ist keine Zone konfiguriert. Standard (NO1) wird verwendet.',
      overlayMissingRate: 'Wechselkurs konnte nicht abgerufen werden',
      overlayFetchFailed: 'Overlay-Daten konnten nicht geladen werden',
      sessionSaved: 'Sitzung gespeichert',
      sessionCreated: 'Sitzung erstellt',
      sessionDeleted: 'Sitzung gelöscht',
      sessionSaveFailed: 'Sitzung konnte nicht gespeichert werden',
      sessionDeleteFailed: 'Sitzung konnte nicht gelöscht werden',
      sessionsLoadFailed: 'Gespeicherte Sitzungen konnten nicht geladen werden',
      devicesLoadFailed: 'Geräte konnten nicht geladen werden',
      buildingsLoadFailed: 'Gebäude konnten nicht geladen werden',
      readingsLoadFailed:
        'Messwerte für ein oder mehrere Geräte konnten nicht geladen werden',
      nameRequired: 'Geben Sie der Sitzung vor dem Speichern einen Namen',
      rangeTooWide:
        'Zeiträume über 7 Tage sind bei diesem Intervall langsam. Wechseln Sie für bessere Leistung zu Täglich.',
    },
    title: 'Echtzeit-Analysen & KPIs',
    pageTitle: 'Analysen',
    searchPlaceholder: 'Geräte suchen…',
    buttons: {
      toggleSidebar: 'Geräteliste ein-/ausblenden',
      showAll: 'Alle anzeigen',
      hideAll: 'Alle ausblenden',
      showTrends: 'Trends anzeigen',
      hideTrends: 'Trends ausblenden',
      clearAll: 'Alle löschen',
      export: 'Exportieren',
    },
    exportMenu: {
      exportAsPNG: 'Als PNG exportieren',
      exportAsCSV: 'Als CSV exportieren',
    },
    thresholds: {
      max: 'Max:',
      min: 'Min:',
      aboveThreshold: 'Über Schwellenwert',
      belowThreshold: 'Unter Schwellenwert',
    },
    timeAxis: {
      label: 'Zeitachse',
      actual: 'Tatsächliche Zeit',
      timeOfDay: 'Tageszeit',
      dayOfWeek: 'Wochentag',
      dayOfMonth: 'Tag im Monat',
      bucket: 'Gruppieren nach',
    },
    legend: {
      manage: 'Verwalten',
      overlays: 'Überlagerungen',
      series: 'Serien',
      trends: 'Trends',
      more: 'weitere',
    },
    overlay: {
      weatherAndElectricity: 'Wetter & Elektrizität',
      none: 'Keine',
      outsideTemperature: 'Außentemperatur',
      elecPrice: 'Strompreis',
      elecPriceFull: 'Strompreis (€/kWh)',
      loadingData: 'Daten werden geladen...',
    },
    collab: {
      viewingSession: 'sieht sich diese Sitzung an',
      updatedSession: 'hat diese Sitzung aktualisiert',
      deletedSession: 'hat diese Sitzung gelöscht',
      conflictTitle: 'Jemand hat eine neuere Version gespeichert',
      conflictDescription:
        'Diese Sitzung wurde von jemand anderem gespeichert, während Sie sie bearbeitet haben. Deren Version laden (Ihre Änderungen gehen verloren) oder mit Ihrer überschreiben.',
      loadTheirs: 'Deren Version laden',
      overwrite: 'Überschreiben',
    },
    picker: {
      wholeBuilding: 'Gesamtes Gebäude',
      noClimateSources: 'Keine Gebäude mit Zonen',
      noAveragesData: 'Noch keine Klimadaten',
      noIndoorSensors: 'Das Gebäude hat keine Innenraumsensoren',
      inSession: 'In der Sitzung',
      searchBuildings: 'Gebäude durchsuchen…',
      noBuildingsMatch: 'Keine passenden Gebäude',
      noWeatherData: 'Noch keine Wetterdaten',
    },
    devices: {
      noDevicesMatch: 'Keine passenden Geräte',
      unnamedDevice: 'Unbenanntes Gerät',
      noDevicesSelected: 'Keine Geräte ausgewählt',
      devicesFound: 'Geräte gefunden',
      noDevicesMatchSearch: 'Keine Geräte entsprechen Ihrer Suche',
      deviceSelected: 'Gerät ausgewählt',
      devicesSelected: 'Geräte ausgewählt',
      shown: 'angezeigt',
      total: 'gesamt',
    },
    chart: {
      zoomHint: 'Gezoomt (Doppelklick zum Zurücksetzen)',
      loadingChartData: 'Diagrammdaten werden geladen...',
      addDevicesToVisualize: 'Geräte hinzufügen um Daten zu visualisieren',
    },
    liveEvents: {
      title: 'Live-Ereignisse',
      events: 'Ereignisse',
      waitingForEvents: 'Warten auf Ereignisse…',
    },
    modal: {
      weatherIntervalHint: 'Wetterdaten haben stündliche Auflösung',
      deviceSettings: 'Geräteeinstellungen',
      addDevices: 'Geräte hinzufügen',
      clear: 'Löschen',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      samplingInterval: 'Abtastintervall',
      dataAggregationGranularity: 'Datenaggregationsgranularität',
      startMustBeBeforeEnd: 'Start muss vor Ende liegen',
      intervals: {
        fiveMinutes: '5 Minuten',
        fifteenMinutes: '15 Minuten',
        oneHour: '1 Stunde',
        daily: 'Täglich',
      },
    },
    connectionStatus: {
      error: 'FEHLER',
      connected: 'VERBUNDEN',
      connecting: 'VERBINDE',
      disconnected: 'GETRENNT',
    },
  },
  eosDashboard: {
    headerTitle: 'Energieübersicht',
    energyKnowledge: {
      title: 'Energieanalyse',
      lastMonth: 'Letzter Monat',
    },
    building: 'Gebäude',
    selectBuilding: 'Gebäude auswählen',
    outdoorTemperature: 'Außentemperatur',
    noData: 'k. A.',
    electricityPrice: 'Strompreis',
    electricityPrices: 'Strompreise',
    noPriceData: 'Keine Preisdaten verfügbar.',
    electricityConsumption: 'Stromverbrauch',
    baseline: 'Baseline',
    viewLabel: 'Ansicht:',
    aggregated: 'Aggregiert',
    meteringPoint: 'Zählpunkt:',
    individualTitle: 'Individuelle Messpunkte',
    eosSourcesTitle: 'Individuelle EOS-Geräte',
    footprint: 'CO₂-Fußabdruck (Einsparung)',
    co2Footprint: 'CO₂-Fußabdruck',
    consumption: 'Verbrauch',
    avgMaxKwp: 'Durchschnittlicher max. kWp',
    higher: 'Höher',
    lower: 'Niedriger',
    normal: 'Normal',
    priceWord: 'Preis',
    vsAverage: 'Gegen Durchschnitt',

    baselineChart: {
      total: 'Gesamt',
      average: 'Durchschnitt',
      leftAxis: 'kWh (Verbrauch)',
      rightAxis: 'kWp (Durchschn. Max.)',
      co2Avg: 'CO₂-Durchschnitt',
      missingData: 'Fehlende Daten',
      missingDataDescription: 'Werte fehlen für diesen Monat',
    },
    energyLabel: {
      title: 'Dynamisches Energielabel',
      withoutSastech: 'Offizielles Label',
      withSastech: 'Dynamisches Label',
      deliveredEnergy: 'Berechnete gelieferte Energie',
      insufficientData:
        'Nur {months} Monate Daten verfügbar. Das Label ist möglicherweise nicht repräsentativ.',
      noFloorArea: 'Nettogrundfläche ist für dieses Gebäude nicht festgelegt.',
      noBuildingCategory:
        'Gebäudekategorie ist für dieses Gebäude nicht festgelegt.',
      fossilFuelShare: 'Anteil Strom/Öl/Gas',
      reduction: 'Reduktion',
      floorArea: 'Nutzfläche',
      annualConsumption: 'Jährlich',
      energyGrade: 'Energieklasse',
      labels: {
        A: 'Sehr energieeffizient',
        B: 'Energieeffizient',
        C: 'Mittlere Effizienz',
        D: 'Unterdurchschnittlich',
        E: 'Geringe Effizienz',
        F: 'Sehr geringe Effizienz',
        G: 'Am wenigsten effizient',
      },
    },
    kpiSection: {
      noChange: '0.0',

      units: {
        kWh: 'kWh',
        kg: 'kg',
        kgCo2: 'kg CO₂',
        krPerKWh: 'kr/kWh',
        degC: '°C',
      },

      trend: {
        increaseSign: '+{percent}%',
        decreaseSign: '-{percent}%',
        neutral: '0.0',
        aboveAverage: 'Über',
        belowAverage: 'Unter',
        atAverage: 'Auf',
        averageThisPeriod: 'Durchschnitt in diesem Zeitraum',
      },

      consumption: {
        title: 'Gesamtverbrauch',
        value: '{value} {unit}',
        subtitle: {
          increased: 'Erhöht um {delta} {unit}',
          reduced: 'Reduziert um {delta} {unit}',
          noChange: 'Keine Änderung beim Verbrauch',
          noBaseline: 'Keine Basisdaten verfügbar',
        },
        detail: 'Energieverbrauch letzte {periodLabel}',
      },

      co2: {
        title: 'Gesamter CO₂-Fußabdruck',
        value: '{value} {unit}',
        subtitle: {
          reduced: 'Reduziert um {delta} {unit}',
          increased: 'Erhöht um {delta} {unit}',
          noChange: 'Keine Änderung bei Emissionen',
          noBaseline: 'Keine Basisdaten verfügbar',
        },
        detail: 'CO₂-Fußabdruck letzte {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Gradtagskorrigiert Verbrauch',
      },

      estate: {
        title: 'Gebäude & Quellen',
        value: '{count} Gebäude',
        subtitle: '{count} Quellen insgesamt',
        detail: 'Derzeit {count} aktive Geräte',
      },

      price: {
        title: 'Aktueller Preis',
        value: '{value} {unit}',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Strompreis gerade jetzt',
      },

      temperature: {
        title: 'Temperatur',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Aktuelle Wetterbedingungen',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Verbrauchsvergleich - letztes Jahr vs. Jahr bis heute',
        baseLineLabel: 'Referenzwert',
        peakHourlyLabel: 'Höchster Spitzenwert',
      },
      consumptionSavings: {
        title: `Verbrauchseinsparungen - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Gesamt',
      totalEnergyConsumption: 'Gesamtenergieverbrauch',
      totalElectricityConsumption: 'Gesamtstromverbrauch',
      energyConsumption: 'Energieverbrauch',
      electricityConsumption: 'Stromverbrauch',
      noDataForSelectedPeriod: 'Keine Daten für den ausgewählten Zeitraum',
      meteringPointTitle: 'Messpunkt: {id}',
      unknownLabel: 'Unbekannt',
      unknownIdLabel: 'Unbekannte ID',
      powerFactorLabel: 'Leistungsfaktor Cos φ',
      powerFactorWarning:
        'Ein Leistungsfaktor unter 0,95 kann zu Tarifaufschlägen führen',
      renameDialog: {
        title: 'Messpunkt umbenennen',
        label: 'Anzeigename',
        helpTextPrefix: 'Ursprüngliche Messpunkt-ID',
      },
      errors: {
        loadAggregatedData: 'Aggregierte Daten konnten nicht geladen werden',
        loadFilteredData: 'Gefilterte Daten konnten nicht geladen werden',
        fetchDisplayName: 'Anzeigename konnte nicht abgerufen werden',
        invalidDisplayName: 'Bitte geben Sie einen gültigen Anzeigenamen ein',
        renameFailed: 'Umbenennen des EOS-Geräts fehlgeschlagen',
        renameUnknown:
          'Beim Umbenennen des EOS-Geräts ist ein Fehler aufgetreten',
        noDataToExport: 'Keine Daten zum Exportieren verfügbar',
        exportFailedTitle: 'Export fehlgeschlagen',
        exportFailedPrefix: 'Datenexport fehlgeschlagen',
        unknownError: 'Unbekannter Fehler',
        enterValidDisplayName:
          'Bitte geben Sie einen gültigen Anzeigenamen ein',
        validationErrorTitle: 'Validierungsfehler',
      },
      tooltip: {
        electricityElhub: 'Strom',
        reactiveEnergy: 'Blindenergie',
        buildingsLabel: 'Gebäude',
        meteringPointsLabel: 'Messpunkte',
        districtHeating: 'Fernwärme',
        solarPv: 'Solarstromproduktion',
        exportedElectricity: 'Eingespeister Strom',
      },
    },
    co2BarChart: {
      baseline: 'Referenzwert',
      legendBaseline: 'Baseline',
      currentValues: 'Aktuelle Werte',
      co2Emissions: 'CO₂-Emissionen',
      dailyEmissions: 'Tägliche Emissionen',
      monthlyEmissions: 'Monatliche Emissionen',
      months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      goal: 'Ziel',
    },
    chartMenu: {
      rename: 'Umbenennen',
      exportExcel: 'Excel exportieren',
      exportCSV: 'CSV exportieren',
    },
    periodOptions: {
      '3days': {
        label: 'Letzte 3 Tage',
        mobileLabel: '3 Tage',
        chartLabel: '3 Tage',
      },
      '30days': {
        label: 'Letzte 30 Tage',
        mobileLabel: '30 Tage',
        chartLabel: '30 Tage',
      },
      '3months': {
        label: 'Letzte 3 Monate',
        mobileLabel: '3 Monate',
        chartLabel: '3 Monate',
      },
    },
    chartSubtitle: {
      today: 'Gesamt für heute',
      oneDay: 'Gesamt für 1 Tag',
      days: 'Gesamt für {days} Tage',
      oneWeek: 'Gesamt für 1 Woche',
      weekAndDays: 'Gesamt für 1 Woche und {days} Tag(e)',
      weeks: 'Gesamt für {weeks} Wochen',
      weeksAndDays: 'Gesamt für {weeks} Wochen und {days} Tag(e)',
      months: 'Gesamt für {months} Monate',
      monthsAndDays: 'Gesamt für {months} Monate und {days} Tag(e)',
      monthsAndWeeks: 'Gesamt für {months} Monate und {weeks} Woche(n)',
    },
    datePicker: {
      startLabel: 'Start',
      endLabel: 'Ende',
    },
    weatherTemperature: {
      noData: 'Keine Wetterdaten verfügbar',
      headerTitle: 'Wettervorhersage',
      headerSubtitle: 'Prognose',
      tooltip: {
        conditions: 'Wetterbedingungen',
        temperature: 'Temperatur',
        wind: 'Wind',
        windDirection: 'Windrichtung',
        pressure: 'Luftdruck',
        cloudCover: 'Bewölkung',
        fog: 'Nebel',
        uvIndex: 'UV-Index',
        precipitation: 'Niederschlag nächste Stunde',
      },
      stats: {
        min: 'Min',
        avg: 'Durchschnitt',
        max: 'Max',
        current: 'Aktuell',
      },
    },
    tempTrend: {
      stable: 'Stabile Außentemperatur',
      graduallyRising: 'Allmählich steigende Temperatur',
      graduallyFalling: 'Allmählich fallende Temperatur',
      rising: 'Steigende Außentemperatur',
      falling: 'Fallende Außentemperatur',
    },
    noDataForPeriod: 'Keine Energiedaten für den gewählten Zeitraum',
    totalEnergy: 'Gesamtenergie',
    filters: {
      noMatch: 'Keine Knoten entsprechen allen ausgewählten Kategorien',
    },
    staleData: {
      warningText: 'Daten von gestern sind nicht verfügbar',
      showingDataFrom: 'Zeigt Daten von',
    },
    sankey: {
      noData: 'Keine Sankey-Daten verfügbar.',
      searchNodes: 'Knoten suchen...',
      selectedNodes: 'Ausgewählte Knoten',
      csvValue: 'Wert (kWh)',
      csvDeviceId: 'Geräte-ID',
    },
  },
  superSettings: {
    securityLog: {
      title: 'Sicherheitsprotokoll',
      levelBadge: 'Stufe 10',
      intro:
        'Anmeldungen, Änderungen, Datenzugriffe und API-Nutzung über alle Kunden. Anmeldungen, Änderungen und Datenzugriffe werden 90 Tage gespeichert, die Nutzung 30 Tage.',
      error: 'Das Sicherheitsprotokoll konnte nicht geladen werden.',
      tabs: {
        overview: 'Übersicht',
        logins: 'Anmeldungen',
        changes: 'Änderungen',
        reads: 'Datenzugriff',
        usage: 'Nutzung',
        sessions: 'Sitzungen',
      },
      filters: {
        period: 'Zeitraum',
        last24h: 'Letzte 24 Stunden',
        last7d: 'Letzte 7 Tage',
        last30d: 'Letzte 30 Tage',
        last90d: 'Letzte 90 Tage',
        custom: 'Benutzerdefiniert',
        vendor: 'Kunde',
        allVendors: 'Alle Kunden',
        exportCsv: 'CSV exportieren',
        refresh: 'Aktualisieren',
      },
      totals: {
        logins: 'Anmeldungen',
        loginsHint: '{users} Benutzer, {ips} IP-Adressen',
        reads: 'Datenzugriff',
        readsHint: '{users} Benutzer',
        readsTooltip:
          'Abrufe von Benutzerlisten, Kundenlisten, Leads und Protokollen',
        failedLogins: 'Fehlgeschlagene Anmeldungen',
        rateLimitedHint: '{count} durch das Ratenlimit gestoppt',
        changes: 'Änderungen',
        deletesHint: '{count} Löschungen',
        accessChanges: 'Zugriffsänderungen',
        accessHint: 'Stufen, Kundenzugriff, Entra ID',
        requests: 'API-Anfragen',
        requestsHint: '{users} aktive Benutzer',
        compromised: 'Möglicherweise kompromittiert',
        compromisedHint: 'Zu prüfende Konten',
        unknownOutcome:
          '{count} Anmeldungen aus der Zeit vor der Ergebniserfassung werden separat gezählt.',
        truncated:
          'Der Zeitraum ist groß; nur die ersten 20 000 Einträge wurden geprüft.',
      },
      attention: {
        title: 'Benötigt Aufmerksamkeit',
        empty: 'In diesem Zeitraum benötigt nichts Aufmerksamkeit.',
        high: 'Hoch',
        medium: 'Mittel',
        low: 'Niedrig',
        showMore: 'Alle {count} anzeigen',
      },
      compromised: {
        title: 'Möglicherweise kompromittierte Konten',
        empty: 'Kein Konto zeigt Anzeichen einer Kompromittierung.',
        help: 'Nutzung, die kein Mensch erzeugen kann, oder eine Sitzung, die gleichzeitig von mehreren Orten genutzt wird.',
      },
      chart: {
        title: 'Anmeldungen pro Tag',
        success: 'Erfolgreich',
        failed: 'Fehlgeschlagen',
        rateLimited: 'Ratenbegrenzt',
      },
      sensitive: {
        title: 'Letzte Zugriffsänderungen',
        empty: 'Keine Zugriffsänderungen in diesem Zeitraum.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} fehlgeschlagene Anmeldungen für {who}, dann eine erfolgreiche Anmeldung',
        failedLogins: '{count} fehlgeschlagene Anmeldungen für {who}',
        failedLoginsIp:
          '{count} fehlgeschlagene Anmeldungen von {ip}, gegen {accounts} Konten',
        rateLimited: '{count} gestoppte Anmeldeversuche für {who}',
        newIp: '{who} hat sich von einer neuen IP-Adresse angemeldet ({ip})',
        levelRaised: '{who} wurde von {by} von Stufe {old} auf {new} angehoben',
        accessChange: 'Zugriff für {who} ({fields}) von {by} geändert',
        userDeleted: '{who} wurde von {by} gelöscht',
        massDelete:
          '{who} hat {count} Datensätze innerhalb von 10 Minuten gelöscht',
        requestBurst: '{who} hat {count} Anfragen in einer Minute gestellt',
        alwaysOn: '{who} war {count} Stunden an einem Tag aktiv',
        parallelLocations:
          '{who} wurde gleichzeitig von {count} IP-Adressen genutzt',
        parallelDevices: '{who} wurde gleichzeitig von {count} Geräten genutzt',
        robotRhythm:
          '{who} hat {count} Minuten lang in maschinenhaft gleichmäßigem Takt Anfragen gestellt',
        changeBurst:
          '{who} hat {count} Änderungen innerhalb von 10 Minuten vorgenommen',
        vendorHopping:
          '{who} hat innerhalb einer Stunde in {count} Kunden gearbeitet',
        readBurst:
          '{who} hat innerhalb von 10 Minuten {count} Mal kritische Daten gelesen',
        unknown: 'Unbekannte Warnung',
        someone: 'unbekanntes Konto',
        occurrences: '{count} Mal in diesem Zeitraum',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Anmeldung nach vielen Fehlern',
        failedLogins: 'Viele fehlgeschlagene Anmeldungen',
        failedLoginsIp: 'Fehlerhafte IP-Adresse',
        rateLimited: 'Ratenbegrenzt',
        newIp: 'Neue IP-Adresse',
        levelRaised: 'Stufe angehoben',
        accessChange: 'Zugriff geändert',
        userDeleted: 'Benutzer gelöscht',
        massDelete: 'Massenlöschung',
        requestBurst: 'Anfragespitze',
        alwaysOn: 'Immer aktiv',
        parallelLocations: 'Mehrere Orte gleichzeitig',
        parallelDevices: 'Mehrere Geräte gleichzeitig',
        robotRhythm: 'Maschinenhafter Takt',
        changeBurst: 'Änderungsspitze',
        vendorHopping: 'Kundenwechsel',
        readBurst: 'Massenabruf',
      },
      logins: {
        time: 'Zeit',
        outcome: 'Ergebnis',
        method: 'Methode',
        account: 'Konto',
        vendor: 'Kunde',
        ip: 'IP-Adresse',
        device: 'Gerät',
        allOutcomes: 'Alle Ergebnisse',
        allFailures: 'Alle Fehler',
        allMethods: 'Alle Methoden',
        searchEmail: 'E-Mail suchen',
        searchIp: 'IP-Adresse',
        filterByIp: 'Anmeldungen von dieser IP anzeigen',
        filterByAccount: 'Anmeldungen für dieses Konto anzeigen',
        empty: 'Keine Anmeldungen passen zu den Filtern.',
      },
      outcomes: {
        success: 'Erfolgreich',
        wrong_password: 'Falsches Passwort',
        unknown_user: 'Unbekannter Benutzer',
        inactive: 'Deaktiviert',
        invalid_input: 'Ungültige Eingabe',
        rate_limited: 'Ratenbegrenzt',
        unknown_vendor: 'Unbekannter Tenant',
        invalid_session: 'Ungültige Sitzung',
        unknown: 'Nicht erfasst',
      },
      methods: {
        password: 'Passwort',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Zeit',
        action: 'Aktion',
        collection: 'Sammlung',
        record: 'Datensatz',
        by: 'Von',
        vendor: 'Kunde',
        endpoint: 'Anfrage',
        history: 'Verlauf',
        allActions: 'Alle Aktionen',
        create: 'Erstellt',
        update: 'Aktualisiert',
        delete: 'Gelöscht',
        collectionPlaceholder: 'Sammlung, z. B. users',
        fieldPlaceholder: 'Feld, z. B. level',
        empty: 'Keine Änderungen passen zu den Filtern.',
        filterByUser: 'Änderungen dieses Benutzers anzeigen',
      },
      reads: {
        time: 'Zeit',
        user: 'Benutzer',
        area: 'Was',
        vendor: 'Kunde',
        ip: 'IP-Adresse',
        device: 'Gerät',
        allAreas: 'Alles außer dem Sicherheitsprotokoll',
        everything: 'Alles, auch das Sicherheitsprotokoll',
        searchIp: 'IP-Adresse',
        filterByUser: 'Zugriffe dieses Benutzers anzeigen',
        filterByIp: 'Zugriffe von dieser IP anzeigen',
        empty: 'Keine Zugriffe entsprechen den Filtern.',
        note: 'Abrufe von Benutzerlisten, Kundenlisten, Leads und Protokollen, 90 Tage gespeichert.',
      },
      readAreas: {
        vendors: 'Kundenliste',
        users: 'Benutzerliste',
        alarmUsers: 'Alarmbenutzer',
        energyLabelLeads: 'Energieausweis-Leads',
        enerskyAccess: 'Enersky-Zugang',
        feedback: 'Feedback',
        requestLogs: 'Anfrageprotokolle',
        securityLog: 'Sicherheitsprotokoll',
        other: 'Sonstiges',
      },
      usage: {
        user: 'Benutzer',
        requests: 'Anfragen',
        peak: 'Spitze pro Minute',
        activeMinutes: 'Aktive Minuten',
        ips: 'IP-Adressen',
        devices: 'Geräte',
        vendors: 'Kunden',
        flags: 'Markierungen',
        flaggedOnly: 'Nur markierte Benutzer',
        compromisedBadge: 'Möglicherweise kompromittiert',
        empty: 'Keine API-Nutzung in diesem Zeitraum.',
        note: 'Die API-Nutzung wird 30 Tage gespeichert.',
      },
      sessions: {
        user: 'Benutzer',
        rights: 'Rechte',
        method: 'Methode',
        ip: 'IP-Adresse',
        device: 'Gerät',
        started: 'Angemeldet',
        lastSeen: 'Zuletzt gesehen',
        status: 'Status',
        open: 'Offen',
        revoked: 'Beendet',
        expired: 'Abgelaufen',
        idle: 'Inaktiv',
        level: 'Stufe {level}',
        tenants: '+{count} Kunden',
        openOnly: 'Nur offene Sitzungen',
        revoke: 'Beenden',
        revokeTitle: 'Diese Sitzung beenden?',
        revokeText: 'Die Sitzung von {who} ({method}, {ip}) wird beendet.',
        cancel: 'Abbrechen',
        revokeFailed: 'Die Sitzung konnte nicht beendet werden.',
        empty: 'Keine Sitzungen passen zu den Filtern.',
        note: 'Eine Sitzung endet {absolute} Stunden nach der Anmeldung oder nach {idle} Stunden ohne Nutzung. Sitzungen werden 90 Tage gespeichert.',
        notEnforced:
          'Sitzungen werden erfasst, aber noch nicht durchgesetzt. Das Beenden markiert eine Sitzung als beendet; der Benutzer wird abgemeldet, sobald die Durchsetzung aktiviert ist.',
      },
      history: {
        title: 'Datensatzverlauf',
        empty: 'Keine erfassten Änderungen für diesen Datensatz.',
        close: 'Schließen',
        open: 'Verlauf dieses Datensatzes anzeigen',
      },
    },
    areasMenu: {
      securityLog: 'Sicherheitsprotokoll',
      createDashboard: 'Dashboard erstellen',
      feedback: 'Feedback',
      projects: 'Projekte',
      icMeter: 'IC-Messgerät',
      lakeSensors: 'See-Sensoren',
      eosDevices: 'EOS-Geräte',
      deviceMapping: 'Gerätezuordnung',
      energyLabeling: 'Energiekennzeichnung',
      alarmSystems: 'Alarmsysteme',
      enerskyAccess: 'Enersky-Zugang',
    },
    dataQuality: {
      title: 'Datenqualitätsinspektor',
      subtitle:
        'Live-Übersicht über alle Sensorgruppen und den Datenstatus der Geräte.',
      noLakes: 'Keine Sensorgruppen gefunden',
      noDevices: 'Keine Geräte',
      allReporting: 'Alle melden',
      missing: 'fehlend',
      device: 'Gerät',
      devices: 'Geräte',
      missingData: 'Fehlende Daten',
    },
    createDashboard: {
      header: 'Neues Kunden-Dashboard',
      sections: {
        companyDetails: 'Firmendaten',
        address: 'Adresse',
        contactDetails: 'Kontaktdaten',
      },
      fields: {
        companyName: 'Firmenname',
        organizationNumber: 'Handelsregisternummer',
        street: 'Straße',
        city: 'Stadt',
        postcode: 'Postleitzahl',
        country: 'Land',
        email: 'E-Mail',
        phoneNumber: 'Telefonnummer',
        timezone: 'Zeitzone des Kunden',
      },
      helperText: {
        organizationNumber: 'Gewerbeanmeldungs-/Handelsregisternummer',
        timezone: 'Lokale Zeitzone des Kunden auswählen',
      },
      buttons: {
        cancel: 'Abbrechen',
        createClient: 'Kunden erstellen',
      },
    },
    sastechFeedback: {
      title: 'Sastech Feedback',
      table: {
        title: 'Feedback-Nachrichten',
        message: 'Nachricht',
        actions: 'Aktionen',
        resolved: 'Gelöst',
        resolvedBy: 'von',
        unResolved: 'Nicht gelöst',
        filter: 'Filter',
        developerFeedback: 'Feedback vom Entwickler',
        comment: 'Kommentar',
        assignDeveloper: 'Entwickler zuweisen',
        suggestedAction: 'Vorgeschlagene Maßnahme',
        tags: 'Tags',
        noTagsProvided: 'Keine Tags angegeben',
        vote: 'Abstimmen',
        resolvedTicketsThisWeek: 'Diese Woche gelöste Tickets',
        last7Days: 'Letzte 7 Tage',
        newTicketsThisWeek: 'Neue Tickets diese Woche',
        featureTicketsThisWeek: 'Feature-Tickets diese Woche',
        bugTicketsThisWeek: 'Bug-Tickets diese Woche',
        resolvedTickets: 'Gelöste Tickets',
      },
      buttons: {
        resolve: 'Lösen',
        save: 'Antwort speichern',
      },
      confirm: {
        resolve: 'Möchten Sie diese Nachricht wirklich als erledigt markieren?',
        delete: 'Möchten Sie diese Nachricht wirklich löschen?',
      },
      details: {
        browserInfo: 'Browser-Info:',
        operatingSystem: 'Betriebssystem',
        path: 'Pfad',
        resolution: 'Auflösung',
        na: 'k. A.',
        screenshotAlt: 'Screenshot',
      },
    },
    alarmSystems: {
      titleEdit: 'Alarmsystem bearbeiten',
      accordion: {
        details: 'Alarm­details',
        heartbeat: 'Heartbeat­details',
        notification: 'Benachrichtigungs­details',
        connectedDevices: 'Verbundene Gerätealarme',
      },
      fields: {
        systemName: 'Name des Alarmsystems',
        description: 'Beschreibung',
        location: 'Standort',
        key: 'Schlüssel',
      },
      heartbeat: {
        explanation:
          'Das Heartbeat-Intervall ist die Zeit in Sekunden zwischen jedem Heartbeat-Signal, das vom Alarmsystem an den Server gesendet wird. Dieses Signal zeigt an, dass das System aktiv und funktionsfähig ist. Wenn der Server innerhalb eines festgelegten Zeitraums kein Signal erhält, kann dies auf ein Problem mit dem System hinweisen.',
        monitor: 'Heartbeat-Monitor',
        hours: 'Stunden',
        minutes: 'Minuten',
        seconds: 'Sekunden',
      },
      notification: {
        type: 'Benachrichtigungstyp',
        selectType: 'Benachrichtigungstyp wählen',
        options: {
          email: 'E-Mail',
          sms: 'SMS',
        },
        recipient: 'Empfänger der Benachrichtigung',
        recipients: 'Benachrichtigungsempfänger',
        selectUser: 'Benutzer auswählen',
        orAddManually: 'Oder E-Mail oder Mobilnummer manuell hinzufügen:',
        addRecipient: 'Empfänger hinzufügen',
        contact: 'E-Mail / Mobilnummer',
        minimumSeverity: 'Mindestschweregrad',
        severityLevels: {
          1: 'Info',
          2: 'Warnung',
          3: 'Gering',
          4: 'Schwer',
          5: 'Kritisch',
        },
        errors: {
          empty: 'Empfänger darf nicht leer sein',
          duplicate: 'Dieser Empfänger ist bereits vorhanden',
          invalidEmail: 'Ungültiges E-Mail-Format',
          selectTypeFirst: 'Bitte zuerst Benachrichtigungstyp wählen',
          enterEmail: 'Bitte eine E-Mail-Adresse eingeben',
          enterMobile: 'Bitte eine Mobilnummer eingeben',
        },
      },
      connectedDevices: {
        empty: 'Keine Gerätealarme mit diesem Alarmsystem verbunden.',
        unnamed: 'Unbenannter Alarm',
      },
      titleCreate: 'Alarmsystem erstellen',
      confirmDelete:
        'Sind Sie sicher, dass Sie dieses Alarmsystem löschen möchten?',
      list: {
        new: 'Neu',
        search: 'Suchen...',
        empty: 'Keine Alarmsysteme gefunden',
      },
      updatedSuccess: 'Alarmsystem erfolgreich aktualisiert',
      createdSuccess: 'Alarmsystem erfolgreich erstellt',
      deletedSuccess: 'Alarmsystem erfolgreich gelöscht',
      updateError: 'Fehler beim Aktualisieren des Alarmsystems',
      createError: 'Fehler beim Erstellen des Alarmsystems',
      deleteError: 'Fehler beim Löschen des Alarmsystems',
      fetchError: 'Fehler beim Abrufen der Alarmsysteme',
      fetchLogsError: 'Fehler beim Abrufen der Alarmprotokolle',
    },
    enerskyAccess: {
      list: {
        header: 'Enersky-Zugriffsdatensätze',
        description:
          'Verwalten Sie den Datenfreigabezugriff und Vertragsstatus für Kunden',
        tableTitle: 'Zugriffsdatensätze',
        addButton: 'Datensatz erstellen',
        emptyState: 'Keine Datensätze gefunden.',
        searchPlaceholder: 'Vorhandene Datensätze suchen…',
        backButton: 'Zurück zu den Datensätzen',
      },

      columns: {
        vendor: 'Anbieter',
        customer: 'Kunde',
        status: 'Status',
      },

      validation: {
        missingVendor: 'Anbieter ist erforderlich.',
        missingFirstName: 'Vorname ist erforderlich.',
        missingLastName: 'Nachname ist erforderlich.',
        missingEmail: 'Eine gültige E-Mail-Adresse ist erforderlich.',
        missingCompanyName:
          'Der Firmenname ist für Geschäftskunden erforderlich.',
        missingOrganizationNumber: 'Die Organisationsnummer ist erforderlich.',
        missingNationalId:
          'Die nationale Identifikationsnummer ist erforderlich.',
      },

      feedback: {
        save: {
          missingInfoTitle: 'Fehlende Informationen',
          missingInfoMessage:
            'Bitte füllen Sie alle erforderlichen Felder aus.',
          createSuccessTitle: 'Datensatz erstellt',
          createSuccessMessage:
            'Datensatz erstellt und Vertrags-E-Mail gesendet.',
          updateSuccessTitle: 'Aktualisiert',
          updateSuccessMessage: 'Kontaktdaten aktualisiert.',
          errorTitle: 'Fehler',
          errorMessage: 'Speichern fehlgeschlagen.',
          duplicateEndUser: 'Dieser Kunde existiert bereits in Enersky.',
        },

        refresh: {
          mpidsTitle: 'Abonnements aktualisiert',
          mpidsMessage: 'MPID-Status aktualisiert.',
          statusTitle: 'Status aktualisiert',
          statusMessage: 'Datensatzstatus und MPIDs aktualisiert.',
          errorTitle: 'Fehler',
          errorMessage: 'Aktualisierung der Daten fehlgeschlagen.',
        },

        resend: {
          title: 'E-Mail gesendet',
          message: 'Die Vertrags-E-Mail wurde erneut an den Kunden gesendet.',
          errorTitle: 'Fehler',
          errorMessage: 'Erneutes Senden der Vertrags-E-Mail fehlgeschlagen.',
        },

        history: {
          title: 'Anfrage für historische Daten in Warteschlange',
          message: 'Daten wurden in die Warteschlange gestellt.',
          errorTitle: 'Fehler',
          errorMessage: 'Einreihen der Messwerte fehlgeschlagen.',
        },

        delete: {
          successTitle: 'Datensatz gelöscht',
          successMessage: 'Der Enersky-Zugriffsdatensatz wurde gelöscht.',
          errorTitle: 'Fehler',
          errorMessage: 'Löschen des Datensatzes fehlgeschlagen.',
        },
      },

      editEnerskyAccess: {
        labels: {
          basicInfo: 'Grundlegende Informationen',
          vendor: 'Anbieter',
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'E-Mail',
          companyName: 'Firmenname',
          privatePerson: 'Privatperson',
          nationalId: 'Nationale Identifikationsnummer',
          organizationNumber: 'Organisationsnummer',
          systemInfo: 'Informationen zum Enersky-Zugriffsdatensatz',
          accessUrl: 'Zugriffs-URL',
          requestId: 'Anfrage-ID',
          errorMessage: 'Fehlermeldung',
          mpidSection: 'Messstellen (MPID)',
          mpid: 'MPID',
          meterNumber: 'Zählernummer',
          address: 'Adresse',
          description: 'Beschreibung',
          priceArea: 'Preiszone',
          status: 'Status',
          actions: 'Aktionen',
          deleteConfirmMessage:
            'Möchten Sie diesen Datensatz wirklich löschen?',
        },

        buttons: {
          resendLink: 'Link erneut senden',
          refreshSubscriptions: 'Abonnements aktualisieren',
          readHistoricalData: 'Historische Daten abrufen',
        },

        status: {
          unknown: 'Unbekannter Status',
        },
        none: 'Keine',
        unknownError: 'Unbekannter Fehler',
      },
      status: {
        Pending: 'Ausstehend',
        'Contract email sent': 'Vertrags-E-Mail gesendet',
        'Contract link requested': 'Vertragslink angefordert',
        Completed: 'Abgeschlossen',
        Error: 'Fehler',
        Unknown: 'Unbekannter Status',
      },
    },

    chirpStackKeys: {
      title: 'Importierte Schlüsseldateien',
      addButton: 'Schlüssel importieren',
      columns: {
        fileName: 'Dateiname',
        uploadedAt: 'Hochgeladen am',
        importedCount: 'Importierte Anzahl',
      },
      importFile: 'ChirpStack-Schlüsseldatei importieren',
      preview: {
        title: 'Vorschau',
        noRows: 'Keine Vorschauzeilen.',
        close: 'Schließen',
        cancel: 'Abbrechen',
        confirm: 'Import bestätigen',
      },
      feedback: {
        loadError: 'Dateien konnten nicht geladen werden',
        previewError: 'Vorschau fehlgeschlagen',
        invalidExcel: 'Ungültige Excel-Datei.',
        missingFile: 'Originaldatei fehlt, bitte erneut auswählen',
        importSuccess: 'Import erfolgreich',
        importError: 'Import fehlgeschlagen',
      },
    },

    icMeterData: 'IC-Messdaten',
    buildingSensorData: 'Gebäudesensordaten',
    eosSensorData: 'EOS-Sensordaten',
    protocol: 'Kommunikationsprotokoll',
  },
  buildings: {
    sidebar: {
      modifyToggle: 'Bearbeiten',
      editBuildingTitle: 'Gebäude bearbeiten',
      buildingOverviewTitle: 'Gebäudeübersicht',
      editZoneTitle: 'Zone bearbeiten',
      outdoorTemperatureTitle: 'Außentemperatur',
      indoorClimateTitle: 'Raumklima',
      buildingTemperature: 'Gebäudetemperatur',
      floorTemperature: 'Etagentemperatur',
      outdoorTempLabel: 'Außentemp.:',
      electricityPriceLabel: 'Strompreis:',
      energyLabel: 'Energie-Label:',
      noData: 'Keine Daten',
      aspaTitle: 'ASPA-Sollwert',
      zoneFloors: {
        selectFloorLabel: 'Zonen-Etage wählen:',
        selectBuildingFloorLabel: 'Gebäude-Etage wählen:',
        changeFloor: '- Etage wechseln -',
        addFloor: 'Etage hinzufügen ',
        groundFloor: 'Erdgeschoss',
      },
    },
    aspa: {
      title: 'ASPA-Einstellungen',
      noPayload: 'Keine ASPA-Daten für dieses Gebäude gefunden.',
      avgTemp: 'Durchschnittstemperatur',
      acrossAllZones: 'Über alle Zonen',
      highestZoneTemp: 'Höchste Zonentemp.',
      peakZoneReading: 'Höchster Zonenwert',
      lastUpdated: 'Zuletzt aktualisiert',
      payloadsReceived: 'Datenpakete empfangen',
      setpointOverview: 'Sollwertübersicht',
      hourView: '24-Stunden-Ansicht',
      hourOfDay: 'Tagesstunde',
      dailySetpoint: 'Täglicher Sollwert (°C)',
      liveSetpoint: 'Aktueller Sollwert (°C)',
      avg: 'Durchschn.',
      peak: 'Spitze',
      trends: 'Trends',
      temperature: 'Temperatur',
      humidity: 'Luftfeuchtigkeit',
      noTrendData: 'Keine Trenddaten.',
      recommendations: 'Empfehlungen',
      noRecommendations: 'Keine Empfehlungen gefunden.',
      actionKeys: {
        cool: 'Kühlung',
        coolingLevel: 'Kühlstufe',
        preCool: 'Vorkühlung',
        heat: 'Heizung',
        heatingLevel: 'Heizstufe',
        preHeat: 'Vorheizung',
      },
      items: 'Einträge',
      on: 'Ein',
      off: 'Aus',
      samples: 'Messungen',
      trendPeriod: 'Letzte 2 Stunden',
    },
    details: {
      header: 'Gebäudedetails',
      form: {
        buildingName: 'Gebäudename',
        active: 'Aktiv',
        buildingInformation: 'Gebäudeinformationen',
        buildingType: 'Gebäudetyp (NS-Standard)',
        buildingCategory: 'Gebäudekategorie',
        constructionYear: 'Baujahr',
        numberOfFloors: 'Anzahl der Etagen',
        netUsableFloorArea: 'Nettogrundfläche (m²)',
        gridRegion: 'Netzregion',
        selectGridRegion: '- Gebiet wählen -',
        mix: 'CO₂-Mix',
        addressAndGps: 'Adresse & GPS',
        street: 'Straße',
        street2: 'Straße 2',
        postCode: 'Postleitzahl',
        city: 'Stadt',
        country: 'Land',
        latitude: 'Breitengrad',
        longitude: 'Längengrad',
        fetchGps: 'GPS holen',
        fillStreetCityError:
          'Bitte sowohl Straße als auch Stadt ausfüllen, um GPS-Koordinaten abzurufen.',
        requiredAddressFields: 'Bitte vor dem Speichern ausfüllen: {fields}.',
        searchCountry: 'Land suchen',
        floorNumber: 'Etage',
        preferredCurrency: 'Bevorzugte Währung',
        climateGoalPercentage: 'Prozentsatz des Klimaziels',
        changeModel: 'Gebäudemodell ändern',
        defaultStartingFloor: 'Startetage',
        startingViewHint:
          'Drehen, verschieben und zoomen Sie die Vorschau, um die Ansicht festzulegen, mit der das Gebäude geöffnet wird.',
        matrikkelData: {
          title: 'Matrikkel-Daten',
          error: 'Abrufen der Matrikkel-Daten fehlgeschlagen',
          errorTitle: 'Fehler',
          matrikkelId: 'Matrikkel-ID',
          cadastralNumber: 'Kataster-Nummer',
          propertyUnitNumber: 'Grundstücksnummer',
          sectionNumber: 'Sektionsnummer',
          unitNumber: 'Einheiten',
          leaseholdNumber: 'Erbpacht-Nummer',
          municipalityName: 'Gemeindename',
          municipalityNumber: 'Gemeindenummer',
          success: 'Erfolg',
          successTitle: 'Matrikkel-Daten erfolgreich abgerufen',
          fetchMatrikkelData: 'Matrikkel-Daten abrufen',
          buildingNumber: 'Gebäudenummer',
          errorMissing: 'Fehlende erforderliche Adressfelder',
          errorTooMany: 'Zu viele Adressen gefunden',
          errorNotFound: 'Keine Adresse gefunden',
          unitId: 'Einheits-ID',
          noUnitIdFound:
            'Keine Einheit an dieser Adresse gefunden. Bitte überprüfen Sie die Adresse auf seeiedom.no und versuchen Sie es erneut.',
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Abschnitt',
          fetchedFromMatrikkel: 'Aus dem Matrikkel abgerufen',
          overrideButton: 'Bruksenhet überschreiben',
          overrideSectionButton: 'Abschnitt überschreiben',
          addButton: 'Bruksenhet hinzufügen',
          addSectionButton: 'Abschnitt hinzufügen',
          manualWarning:
            'Nur erforderlich, wenn Matrikkel-Daten fehlen oder fehlerhaft sind.',
          buildingType: 'Gebäudetyp',
        },
      },
      baseline: {
        title: 'Baseline',
        recalcButton: 'Baseline neu berechnen',
        confirmRecalculate: 'Möchten Sie die Baseline wirklich neu berechnen?',
        success: 'Baseline erfolgreich neu berechnet',
        error: 'Baseline konnte nicht neu berechnet werden',
        subscriptions: {
          title: 'Elhub-Abonnements',
          loading: 'Abonnements werden geladen …',
          emptyState:
            'Keine Abonnements gefunden. Fügen Sie unten eines hinzu.',
          actions: {
            unsubscribe: 'Abmelden',
            subscribe: 'Abonnieren',
            delete: 'Löschen',
            addPlaceholder: 'Zählpunkt-ID eingeben',
            status: {
              waitingApproval:
                'Warte auf Genehmigung der Elhub-Anfrage durch Kunden',
            },
            validation: {
              onlyDigits: 'Zählpunkt-ID darf nur Ziffern enthalten',
              exactLength:
                'Zählpunkt-ID muss genau 18 Ziffern haben (z. B. 707057500042153290)',
              startsWith: 'Zählpunkt-ID muss mit 7070575000 beginnen',
              unique: 'Zählpunkt-ID muss eindeutig sein',
            },
            move: {
              selectTargetBuilding: '- Zielgebäude wählen -',
              moveSelected: 'Ausgewählte verschieben',
              instructions:
                'Wählen Sie Abonnements per Checkbox. Dies kann bis zu 1 Minute pro Abonnement dauern.',
              moveSubscriptions: 'Abonnements verschieben',
            },
            feedback: {
              subscribeSuccess: 'Abonnementanfrage gesendet',
              unsubscribeSuccess: 'Erfolgreich abgemeldet',
              deleteSuccess: 'Abonnement gelöscht',
              subscribeError: 'Abonnementanfrage fehlgeschlagen',
              unsubscribeError: 'Abmelden fehlgeschlagen',
              deleteError: 'Abonnement konnte nicht gelöscht werden',
            },
          },
        },
      },
      report: {
        title: 'Bericht',
      },
    },
    model3d: {
      title: '3D-Modell',
    },
    zoneEdit: {
      title: 'Zoneneinstellungen',
      form: {
        zoneName: 'Zonenname',
        floorNumber: 'Etage',
        selectCategory: 'Kategorie wählen',
        isHeated: 'Beheizte Zone',
        displayHint: 'So erscheint die Zone in der 3D-Ansicht.',
        cardSize: 'Kartengröße',
        zoneColor: 'Zonenfarbe',
        devices: {
          availableDevices: 'Verfügbare Geräte',
          zoneDevices: 'Zonengeräte',
          noMatches: 'Keine Geräte entsprechen der Suche',
        },
        deleteButton: 'Zone löschen',
        deleteZoneDescription: 'Entfernt die Zone dauerhaft.',
        deleteZoneConfirm: 'Möchten Sie diese Zone wirklich löschen?',
        deleteError: 'Zone konnte nicht gelöscht werden',
      },
    },
    technicalRoom: {
      titles: 'Technische Räume',
      emptyState: 'Keine technischen Räume gefunden.',
      technicalRoomDescription: 'Beschreibung des technischen Raums',
      technicalRoomNamePlaceholder: 'Name des technischen Raums',
      technicalRoomDevices: 'Geräte im technischen Raum',
      addDevice: 'Gerät hinzufügen',
      technicalRoomDevice: 'Gerät im technischen Raum',
      removeDevice: 'Entfernen',
      searchPlaceholder: 'Technischen Raum suchen',
      technicalRoomOverview: 'Übersicht Technischer Raum',
      technicalRoomValue: 'Wert',
      technicalRoomSeen: 'Zuletzt gesehen',
      addTechnicalRoom: 'Technischen Raum hinzufügen',
      addDeviceButton: 'Gerät hinzufügen',
      removeDeviceButton: 'Entfernen',
      deviceType: 'Gerätetyp',
      editorTitle: 'Technische Räume',
      selectRoom: 'Technischen Raum auswählen',
      threeDModel: '3D-Modell',
      replace: 'Ersetzen',
      selectModel: '3D-Modell auswählen',
      modelDefaultsGroup: 'Standardmodelle',
      noModel: 'Kein 3D-Modell mit diesem Raum verknüpft.',
      bind: 'Verknüpfen',
      rebind: 'Neu verknüpfen',
      unbind: 'Verknüpfung lösen',
      boundTo: 'Verknüpft mit',
      notBound: 'Nicht verknüpft',
      hide: 'In 3D ausblenden',
      show: 'In 3D anzeigen',
      size: 'Größe',
      remove: 'Aus Raum entfernen',
      pickingHint: 'Modell anklicken zum Verknüpfen',
      pickingCardHint:
        'Teil des Modells anklicken, oder den Hintergrund, um die Karte frei zu platzieren',
      searchDevices: 'Geräte suchen…',
      noDevicesAvailable: 'Keine Geräte verfügbar',
      noMatches: 'Keine Treffer',
      unnamedDevice: 'Unbenanntes Gerät',
      couldNotAddDevice: 'Gerät konnte nicht hinzugefügt werden',
      noReadings24h: 'Keine Messwerte in den letzten 24 Stunden',
      dragToReposition: 'Zum Verschieben ziehen',
      hideGraph: 'Graph ausblenden',
      showGraph: 'Graph anzeigen',
      lockedHint: 'Ansicht entsperren, um Geräte zu verschieben',
      clickToEdit: 'Zum Bearbeiten klicken',
      noDescription: 'Keine Beschreibung',
      noTitle: 'Kein Titel',
      showCardTitle: 'Kartentitel',
      showDeviceName: 'Gerätename',
      cardVisualization: 'Kartenvisualisierung',
      modelAnimation: 'Modellanimation',
      showLine: 'Verbindungslinie',
      lineColor: 'Linienfarbe',
      resetColor: 'Farbe zurücksetzen',
      darkTheme: 'Dunkles Design',
      showUnit: 'Einheit',
      trendLine: 'Trendlinie',
      trendBars: 'Trendbalken',
      showUpdated: 'Zuletzt aktualisiert',
      visualizationRules: 'Visualisierungsregeln',
      ruleDataKey: 'Datenschlüssel',
      ruleValue: 'Wert',
      triggers: 'Auslöser',
      addTrigger: 'Auslöser hinzufügen',
      ruleOff: 'Aus',
      ruleSlow: 'Langsam',
      ruleFast: 'Schnell',
      ruleNoEffect: 'Kein Effekt',
      ruleNoColor: 'Keine Farbe',
      ruleReverse: 'Richtung umkehren',
      particleFlow: 'Partikelströmung',
      drawFlow: 'Strömung zeichnen',
      flowHint: 'Klicken Sie auf das Modell, um Punkte hinzuzufügen.',
      flowFollowsHint:
        'Die Partikel folgen den Auslösern der Modellanimation. Ist die Animation aus, stoppen die Partikel.',
      flowColorHint:
        'Klicken Sie im Modell auf einen Punkt der Strömung, um ab dort die Farbe zu ändern.',
      flowColorFromPoint: 'Farbe ab gewähltem Punkt',
      flowFollows: 'Folgt der Animation',
      particles: 'Partikel',
      ruleDataKeyRequired:
        'Wählen Sie einen Datenschlüssel für die Visualisierungsregel',
      newTechnicalRoom: 'Neuer technischer Raum',
      roomNamePlaceholder: 'z. B. Lüftung, Heizraum, Wärmepumpe',
      selectBuilding: 'Gebäude auswählen',
      nameRequired: 'Name ist erforderlich',
      buildingRequired: 'Gebäude ist erforderlich',
      couldNotCreateRoom: 'Raum konnte nicht erstellt werden',
      creating: 'Wird erstellt',
      loadError: 'Technischer Raum konnte nicht geladen werden',
      textPlaceholder: 'Text eingeben…',
      noText: 'Kein Text',
      linkToRoom: 'Zum Raum wechseln',
      noLink: 'Kein Link',
      linkHint:
        'In der gesperrten Ansicht öffnet ein Klick auf das Modell oder die Karte diesen Raum.',
      confirmRemoveAnnotation:
        'Möchten Sie diesen Text wirklich aus dem Raum entfernen?',
      dragToReorder: 'Ziehen zum Sortieren',
      drawFrame: 'Rahmen zeichnen',
      redrawFrame: 'Rahmen neu zeichnen',
      frameDrawHint: 'Zwei Ecken in der Zeichnung anklicken',
      noFrame: 'Kein Rahmen gezeichnet',
      frameDrawn: 'Rahmen gezeichnet',
      confirmRemoveFrame:
        'Möchten Sie diesen Rahmen wirklich aus dem Raum entfernen?',
      confirmRemoveLink:
        'Möchten Sie diesen Link wirklich aus dem Raum entfernen?',
      annotationsTab: 'Links und Text',
      noAnnotations: 'Keine Links oder Texte in diesem Raum.',
      placeText: 'Platzieren',
      replaceText: 'Neu platzieren',
      placed: 'Platziert',
      placeTextHint: 'In der Zeichnung dort klicken, wo der Text stehen soll',
      placeInfoHint: 'In der Zeichnung dort klicken, wo die Blase stehen soll',
      confirmRemoveInfo:
        'Möchten Sie diese Infoblase wirklich aus dem Raum entfernen?',
      ruleAngle: 'Winkel (Grad)',
      infoPanel: 'Alarme und Betriebskalender',
      alarmsTab: 'Alarme',
      calendarsTab: 'Betriebskalender',
      noAlarmSystems: 'Mit diesem Raum sind keine Alarmsysteme verbunden.',
      noCalendars: 'Mit diesem Raum sind keine Betriebskalender verbunden.',
      systemAlarm: 'Systemalarm',
      openInSettings: 'In den Einstellungen öffnen',
      confirmRemoveDevice:
        'Möchten Sie dieses Gerät wirklich aus dem Raum entfernen?',
      attributes: 'Attribute',
      selectAttribute: 'Attribut auswählen',
      mappedGroup: 'Zugeordnete Attribute',
      payloadGroup: 'Rohdaten',
      mappedNoneText: 'Keine verfügbar,',
      assignHere: 'hier zuordnen',
      confirmDeleteRoom: 'Möchten Sie {name} wirklich löschen?',
      roomDeleted: 'Technischer Raum gelöscht',
      renameRoom: 'Technischen Raum umbenennen',
      noTechnicalRoomsForType: 'Keine technischen Räume dieses Typs gefunden',
      noDevices: 'Keine Geräte in diesem technischen Raum.',
      technicalRoomTypeLabel: 'Typ des technischen Raums',
      technicalRoomTypes: {
        type: 'Typ auswählen',
        hvac: 'HLK',
        technical: 'Technischer Raum',
        electrical: 'Elektrisch',
        plumbing: 'Sanitär',
        other: 'Andere',
      },
      message: {
        success: 'Technischer Raum erfolgreich erstellt',
        updateSuccess: 'Technischer Raum erfolgreich aktualisiert',
        deleteSuccess: 'Technischer Raum erfolgreich gelöscht',
        error: 'Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten',
        deleteConfirm: 'Möchten Sie diesen technischen Raum wirklich löschen?',
      },
    },
  },
  threeD: {
    lockView: 'Ansicht sperren',
    unlockView: 'Ansicht entsperren',
  },

  buildings3D: {
    header: {
      buildingTab: 'Gebäude',
      technicalTab: 'Technik',
    },
    footer: {
      home: 'Start',
      measure: 'Messen',
      stopMeasure: 'Messung stoppen',
      explode: 'Explodieren',
      screenshot: 'Screenshot',
      lock: 'Sperren',
      unlock: 'Entsperren',
    },
    climate: {
      buildingClimate: 'Innenraumklima',
      levelsTitle: 'Bereiche',
      startLabel: 'Start',
      endLabel: 'Ende',
      apply: 'Anwenden',
      avgTemperature: 'Durchschnittstemperatur',
      avgHumidity: 'Durchschnittliche Luftfeuchtigkeit',
      avgCo2: 'Durchschnittliches CO₂',
      floor: 'Etage',
      wholeBuilding: 'Gesamtes Gebäude',
      noTrendData: 'Keine Daten',
      fetchData: 'Daten abrufen',
      startMustBeBeforeEnd: 'Start muss vor Ende liegen.',
      groundFloor: 'Erdgeschoss',
      weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    },
    status: {
      good: 'Gut',
      tooLow: 'Zu niedrig',
      tooHigh: 'Zu hoch',
      warning: 'Warnung',
      poor: 'Schlecht',
    },
    warnings: {
      title: 'Warnungen',
      highCo2: 'Hohes CO₂',
      highTemp: 'Hohe Temperatur',
      lowTemp: 'Niedrige Temperatur',
    },
    alarmLog: {
      title: 'Alarmprotokoll',
      last24h: 'Letzte 24 Stunden',
      last7d: 'Letzte 7 Tage',
      last30d: 'Letzte 30 Tage',
      custom: 'Benutzerdefiniert',
      zone: 'Zone',
      activeNow: 'Jetzt aktiv',
      today: 'Heute',
      yesterday: 'Gestern',
      earlier: 'Früher',
      empty: 'Keine Alarme in diesem Zeitraum',
      loadError: 'Alarmprotokoll konnte nicht geladen werden.',
      unknownZone: 'Unbekannte Zone',
    },
    deviceLayer: {
      moveDevices: 'Modelle verschieben',
      moveHint: 'Ziehen zum Verschieben · ⇧ drehen · ⌘ Höhe',
      moveThisDevice: 'Dieses Gerät verschieben',
      doneMoving: 'Verschieben beenden',
      changeModel: 'Modell wechseln',
      showDataBox: 'Datenbox anzeigen',
      hideDataBox: 'Datenbox ausblenden',
      modelSize: 'Modellgröße',
      dataSize: 'Datengröße',
      hideZones: 'Zonen ausblenden',
      showZones: 'Zonen anzeigen',
      hideModels: 'Modelle ausblenden',
      showModels: 'Modelle anzeigen',
      hideModel: 'Modell ausblenden',
      showModel: 'Modell anzeigen',
      suggested: 'Vorgeschlagen',
      noModelsInCategory: 'Noch keine Modelle in dieser Kategorie',
      controllers: 'Controller',
      models: {
        radiatorGlb: 'Heizkörper',
        panelOvenGlb: 'Heizpaneel',
        heatpumpGlb: 'Wärmepumpe',
        indoorClimateGlb: 'Innenklima',
        icmSensorGlb: 'ICM Sensor',
        climateHubGlb: 'Klima Hub',
        ventilationOutletGlb: 'Lüftungsauslass',
        ventilationGrillGlb: 'Lüftungsgitter',
      },
    },
    zoneControls: {
      leaveFloor: 'Verlassen',
      drawZone: 'Doppelklick zum Beenden',
      clearZones: 'Zonen löschen',
      clickFloorToIsolate: 'Auf Etage klicken zum Isolieren',
      select: 'Auswählen',
      rectangle: 'Rechteck',
      circle: 'Kreis',
      polygon: 'Polygon',
      zoneNameLabel: 'Zonenname',
      heightLabel: 'Höhe',
      editVertexHint:
        'Punkte ziehen zum Bearbeiten, doppelklicken zum Hinzufügen',
      unnamedZone: 'Unbenannte Zone',
      zoneNameRequired: 'Zonenname ist erforderlich',
      zonesMissingData: 'Zonen ohne 3D Daten',
      zonesMissingDataTitle: 'Zonen ohne 3D Modelldaten:',
      floorLabel: 'Etage',
      zoneCreated: 'Zone erstellt',
      zoneUpdated: 'Zone aktualisiert',
      zoneDeleted: 'Zone gelöscht',
      failedToCreateZone: 'Zone konnte nicht erstellt werden',
      failedToUpdateZone: 'Zone konnte nicht aktualisiert werden',
      failedToDeleteZone: 'Zone konnte nicht gelöscht werden',
      confirmDeleteZoneTitle: 'Zone löschen?',
      confirmDeleteZoneMessage:
        'Möchten Sie diese Zone wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Gerätealarm erfolgreich aktualisiert',
    createdSuccess: 'Gerätealarm erfolgreich erstellt',
    deletedSuccess: 'Gerätealarm erfolgreich gelöscht',

    editTitle: 'Gerätealarm bearbeiten',
    createTitle: 'Gerätealarm erstellen',
    title: 'Gerätealarme',
    manageAlarmsForDevice: 'Alarme für {device} verwalten',
    recipients: 'Empfängerliste',

    alarmDetails: 'Alarmdetails',
    deviceSelection: 'Geräteauswahl',
    alarmConditions: 'Alarmbedingungen',
    condition: 'Bedingung',
    conditions: 'Bedingungen',
    noConditions: 'Noch keine Bedingungen hinzugefügt.',
    noConditionsSaveError: 'Mindestens eine Bedingung ist erforderlich',

    name: 'Name',
    description: 'Beschreibung',
    alarmSystem: 'Alarmsystem',
    selectDevice: 'Gerät auswählen',
    dataKey: 'Datenschlüssel',
    selectKey: 'Schlüssel auswählen',
    level: 'Stufe',
    operator: 'Operator',
    value: 'Wert',
    duration: 'Dauer (Min)',
    message: 'Nachricht',
    active: 'Aktiv',

    greaterThan: 'Größer als',
    lessThan: 'Kleiner als',
    equal: 'Gleich',
    notEqual: 'Ungleich',
    missing: 'Fehlend',
    unchanged: 'Unverändert',

    addTrigger: 'Auslöser hinzufügen',
    addCondition: 'Bedingung hinzufügen',
    triggers: 'Auslöser',

    standardDevices: 'Standardgeräte',
    eosDevices: 'EOS-Geräte',
    noDataKeys: 'Keine Datenschlüssel für dieses Gerät verfügbar.',

    noAlarmSystems: 'Keine Alarmsysteme verfügbar.',
    pleaseCreateFirst: 'Bitte erstellen Sie zuerst eines',
    selectDeviceFirst:
      'Bitte wählen Sie zuerst ein Gerät aus, um Alarmbedingungen zu konfigurieren.',
    messagePlaceholder: 'Anzuzeigende Warnmeldung...',
    confirmDelete:
      'Sind Sie sicher, dass Sie diesen Gerätealarm löschen möchten?',
    list: {
      new: 'Neu',
      search: 'Suchen...',
      empty: 'Keine Gerätealarme gefunden',
    },
    deleteAlarmTitle: 'Alarm löschen',
    deleteAlarmDescription:
      'Diese Aktion kann nicht rückgängig gemacht werden.',
  },

  settings: {
    areas: {
      home: 'Start',
      vendor: 'Allgemein',
      devices: 'Geräte',
      eos_devices: 'EOS-Geräte',
      categories: 'Kategorien',
      users: 'Benutzer',
      themes: 'Designs',
      integrationOverview: 'API-Integrationen',
      fileCloud: 'Datei-Cloud',
      energyPrices: 'Energiepreise',
      alarms: 'Alarme',
      alarmSystemDescription:
        'Verwalten und Anpassen von Alarmsystemen mit maßgeschneiderten Benachrichtigungen und Herzfrequenzüberwachung, um über kritische Ereignisse informiert zu bleiben und rechtzeitige Reaktionen zu gewährleisten.',
      baseline: 'Basislinie',
      technicalRoomOverview: 'Technische Räume',
      aspaSetup: 'ASPA Einrichtung',
      controlStrategy: 'Steuerungsstrategie',
      operatingCalendar: 'Betriebskalender',
      setpoint: 'Sollwerte',
    },

    aspaSetup: {
      list: {
        header: 'ASPA Einrichtung',
        addButton: 'ASPA Einrichtung hinzufügen',
        emptyState: 'Keine ASPA Einrichtungen gefunden.',
        searchPlaceholder: 'Suchen...',
      },
      edit: {
        name: 'ASPA Einrichtungsname',
        units: 'Einheiten',
        addUnit: 'Einheit hinzufügen',
        unitName: 'Einheitsname',
        setpoints: 'Sollwerte',
        zones: 'Zonen',
        removeUnit: 'Einheit entfernen',
        copyMondayToWeekdays: 'Montag auf Wochentage kopieren',
        copyMondayToAllDays: 'Montag auf alle Tage kopieren',
      },
      feedback: {
        deleteSuccess: 'ASPA Einrichtung erfolgreich gelöscht',
        deleteError:
          'Beim Löschen der ASPA Einrichtung ist ein Fehler aufgetreten',
        updateSuccess: 'ASPA Einrichtung erfolgreich aktualisiert',
        updateError:
          'Beim Aktualisieren der ASPA Einrichtung ist ein Fehler aufgetreten',
        createSuccess: 'ASPA Einrichtung erfolgreich erstellt',
        createError:
          'Beim Erstellen der ASPA Einrichtung ist ein Fehler aufgetreten',
        saveError:
          'Beim Speichern der ASPA Einrichtung ist ein Fehler aufgetreten',
      },
    },

    energyPrices: {
      list: {
        add: 'Energiepreis hinzufügen',
        header: 'Energiepreis-Einstellungen',
        emptyState: 'Keine Energiepreis-Einstellungen gefunden.',
        searchPlaceholder: 'Energiepreis-Einstellungen suchen...',
      },

      name: 'Name',
      notes: 'Notizen',
      building: 'Gebäude',
      selectBuilding: 'Gebäude auswählen',
      validFrom: 'Gültig ab',
      validTo: 'Gültig bis',
      ongoing: 'Laufend',
      notSpecified: 'Nicht angegeben',

      electricityDetails: 'Stromdetails',
      priceModel: 'Preismodell',
      fixed: 'Festpreis',
      spotMarkup: 'Spot + Aufschlag',
      fixedPricePerKWh: 'Festpreis pro kWh',
      spotMarkupPerKWh: 'Aufschlag pro kWh',

      supplierMonthlyFee: 'Monatliche Lieferantengebühr',
      co2Emissions: 'CO₂-Emissionen (gCO₂/kWh)',

      gridTariffs: 'Netzentgelte',
      gridTariff: 'Netzentgelt',
      fixedMonthly: 'Feste Monatsgebühr',
      energyPerKWh: 'Energie pro kWh',
      demandPerKWMonthly: 'Leistungsentgelt pro kW und Monat',
      consumptionTaxPerKWh: 'Verbrauchssteuer pro kWh',

      energySources: 'Energiequellen',
      addEnergySources: 'Energiequellen hinzufügen',
      energySource: 'Informationen zur Energiequelle',
      sourceName: 'Quellenname',
      electricity: 'Gelieferter Strom',
      electricityPrice: 'Strompreis',
      electricityProduced: 'Erzeugter Strom',
      electricityExported: 'Exportierter Strom',

      districtHeating: 'Fernwärme',
      districtHeatingSource: 'Energiequelle der Fernwärme',
      districtHeatingPrice: 'Fernwärmepreis',
      districtHeatingEnergyPrice: 'Energiepreis (kr/kWh)',
      districtHeatingDemandPerKWMonthly:
        'Höchste gemessene Leistung (kr/kW/Monat)',

      fuelSources: 'Brennstoffquellen',
      fuelSource: 'Informationen zur Brennstoffquelle',
      fuelType: 'Energiequelle',

      propane: 'Propan',
      fuelOilDiesel: 'Heizöl / Diesel',
      lng: 'Erdgas (LNG)',
      kerosene: 'Kerosin',
      pelletsBricks: 'Pellets / Briketts',
      biodiesel: 'Biodiesel',
      biogas: 'Biogas',
      other: 'Sonstiges',

      consumptionUnit: 'Verbrauchseinheit',
      kg: 'kg',
      liter: 'Liter',
      unitPrice: 'Stückpreis',
      consumption: 'Verbrauch',
      conversionFactorToKWh: 'Umrechnungsfaktor in kWh',

      periodLabel: 'Zeitraum',
      periodLabelPlural: 'Zeiträume',
      periodName: 'Zeitraumname',
      addPeriod: 'Zeitraum hinzufügen',
      removePeriod: 'Zeitraum entfernen',
      removePeriodConfirmation:
        'Möchten Sie diesen Zeitraum wirklich entfernen?',
      noPeriodsDefined: 'Keine Zeiträume.',
      overlappingPeriodsError:
        'Die Zeiträume "{p1}" und "{p2}" überschneiden sich.\n\n' +
        'Es ist nicht möglich, zwei Zeiträume gleichzeitig anzuwenden (gleiche Monate und sich überschneidende Zeiten). ' +
        'Passe die Monate oder aktiven Zeiten an, bevor du speicherst.',
      confirmRemovePeriod: 'Möchten Sie diesen Zeitraum wirklich entfernen?',
      mixedMonthsError:
        'Es ist nicht möglich, bestimmte Monate mit "allen Monaten" (leere Monate) über verschiedene Zeiträume zu mischen.\n\n' +
        'Diese Zeiträume müssen Monate auswählen: {periods}\n\n' +
        'Tipp: Wählen Sie Monate für alle Zeiträume oder lassen Sie die Monate für alle Zeiträume leer.',

      generalInformation: 'Allgemeine Informationen',
      activeMonths: 'Aktive Monate (alle, wenn leer)',
      activeBetween: 'Aktive Zeiten (ganztägig, wenn leer)',
      chosenMonths: 'Aktive Monate',
      activeHours: 'Aktive Zeiten',
      allYear: 'Ganzjährig',
      allDay: 'Ganztägig',
      addAdditionalTimer: 'Weiteres Zeitintervall hinzufügen',
      startTime: 'Startzeit ',
      endTime: 'Endzeit ',
      timeRangeInvalid: 'Die Endzeit muss nach der Startzeit liegen',
      timeRangesOverlap: 'Zeitintervalle dürfen sich nicht überschneiden',
      timeRangeEqual: 'Start- und Endzeit dürfen nicht identisch sein',

      co2Source: 'Energieart der Fernwärme',
      co2Array: [
        'Strom',
        'Abfall',
        'Leichtes Heizöl',
        'Schweres Heizöl',
        'Flüssiggas (LPG)',
        'Erdgas (LNG)',
        'Primäre Holzbiomasse',
        'Sekundäre Holzbiomasse',
        'RT-Hackschnitzel',
        'Pellets, Briketts und Pulver',
        'Bioöl',
        'Wärmepumpe',
      ],

      fixedFees: 'Fixe Gebühren',
      substationFee: 'Übergabestationsgebühr (pro Monat)',
      reactiveEffect: 'Gebühr für Blindleistung',
      connectedDevices: 'Verbundene Geräte',
      noConnectedDevices: 'Keine verbundenen Geräte',
      deletedDevice: 'Gelöscht',
      removeSource: 'Quelle entfernen',
      noLinkedDevices: 'Keine verknüpften Geräte',
      linked: 'Verknüpfte Geräte',
      unlinkDeviceMessage:
        'Sind Sie sicher, dass Sie dieses Gerät entfernen möchten?',

      linkSourceTitle: 'Quelle mit EOS-Gerät verknüpfen',
      linkSource: 'Quelle mit EOS-Geräten verknüpfen',
      linkSourceDescription:
        'Wählen Sie die EOS-Geräte aus, die mit dieser Energiequelle verknüpft sind.',

      removeElectricitySourceConfirmation:
        'Möchten Sie die Stromquelle wirklich entfernen ',
      removeDistrictHeatingSourceConfirmation:
        'Möchten Sie die Fernwärmequelle wirklich entfernen ',
      removeFuelSourceConfirmation:
        'Möchten Sie die Brennstoffquelle wirklich entfernen ',
    },

    setpoint: {
      title: 'Sollwerte',
      backToList: 'Alle Sollwerte',
      description:
        'Grenzwerte für Temperatur, Feuchtigkeit und CO₂ je Gebäude und Zone.',
      searchPlaceholder: 'Sollwerte suchen …',
      emptyState: 'Noch keine Sollwerte.',
      addButton: 'Neuer Sollwert',
      loadError: 'Die Sollwerte konnten nicht geladen werden.',
      zonesLoadError: 'Die Zonen konnten nicht geladen werden.',
      saveError: 'Der Sollwert konnte nicht gespeichert werden.',
      deleteError: 'Der Sollwert konnte nicht gelöscht werden.',
      requiredError: 'Diese Felder sind erforderlich:',
      deleteConfirmTitle: 'Sollwert löschen',
      deleteConfirmMessage:
        'Möchten Sie diesen Sollwert wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
      editTitle: 'Sollwert bearbeiten',
      newTitle: 'Neuer Sollwert',
      editDescription: 'Die Grenzwerte gelten für die ausgewählten Zonen.',
      saveButton: 'Sollwert speichern',
      openSetpoint: 'Sollwert öffnen',
      buildingSection: 'Gebäude',
      building: 'Gebäude',
      name: 'Name',
      namePlaceholder: 'z. B. Büro Standard',
      zonesSection: 'Zonen',
      selectAll: 'Alle auswählen',
      clearAll: 'Alle entfernen',
      noZones: 'Wählen Sie ein Gebäude, um dessen Zonen zu sehen.',
      allZonesTaken: 'Alle Zonen dieses Gebäudes haben bereits einen Sollwert.',
      zonesTakenError:
        'Eine oder mehrere Zonen gehören bereits zu einem anderen Sollwert.',
      noZonesSelected: 'Keine Zonen ausgewählt',
      floor: 'Etage',
      noFloor: '—',
      limitsSection: 'Grenzwerte',
      columns: {
        name: 'Name',
        building: 'Gebäude',
        zones: 'Zonen',
        inOperation: 'In Betrieb',
        outsideOperation: 'Außer Betrieb',
        interval: 'Prüfintervall',
      },
    },
    operatingCalendar: {
      backToList: 'Alle Betriebskalender',
      title: 'Betriebskalender',
      description:
        'Normale Betriebszeiten pro Gebäude und Zone, mit außerordentlichem Betrieb darüber.',
      searchPlaceholder: 'Betriebskalender durchsuchen …',
      emptyState: 'Noch keine Betriebskalender.',
      addButton: 'Neuer Betriebskalender',
      running: 'Laufend, ohne Enddatum',
      openCalendar: 'Kalender öffnen',
      zonesLoadError: 'Die Zonen konnten nicht geladen werden.',
      loadError: 'Die Betriebskalender konnten nicht geladen werden.',
      saveError: 'Der Betriebskalender konnte nicht gespeichert werden.',
      deleteError: 'Der Betriebskalender konnte nicht gelöscht werden.',
      requiredError: 'Diese Felder sind Pflichtfelder:',
      deleteConfirmTitle: 'Betriebskalender löschen',
      deleteConfirmMessage:
        'Soll dieser Betriebskalender wirklich gelöscht werden? Das kann nicht rückgängig gemacht werden.',
      editTitle: 'Normalbetrieb festlegen',
      editDescription:
        'Feste wöchentliche Betriebszeiten für die gewählten Zonen.',
      saveButton: 'Normalbetrieb speichern',
      buildingSection: 'Gebäude',
      building: 'Gebäude',
      zonesSection: 'Zonen',
      selectAll: 'Alle auswählen',
      clearAll: 'Auswahl aufheben',
      noZonesSelected: 'Keine Zonen ausgewählt',
      zonesTakenError:
        'Eine oder mehrere Zonen gehören bereits zu einem anderen Betriebskalender.',
      allZonesTaken:
        'Alle Zonen in diesem Gebäude gehören bereits zu einem Betriebskalender.',
      noZones: 'Gebäude wählen, um die Zonen zu sehen.',
      floor: 'Etage',
      noFloor: 'Ohne Etage',
      validitySection: 'Name und Gültigkeit',
      name: 'Name',
      validFrom: 'Gültig ab',
      validTo: 'Gültig bis',
      weekPlanSection: 'Wochenplan',
      copyMonday: 'Montag auf alle Werktage kopieren',
      noOperation: 'Kein Betrieb',
      weeklyTotal: 'Summe pro Woche',
      from: 'Von',
      to: 'Bis',
      calendarTitle: 'Betriebskalender',
      week: 'Woche',
      previousWeek: 'Vorherige Woche',
      nextWeek: 'Nächste Woche',
      today: 'Heute',
      editNormal: 'Normalbetrieb',
      addOverride: 'Außerordentlichen Betrieb eintragen',
      thisWeek: 'Diese Woche',
      operatingHours: 'Betriebsstunden',
      extraordinaryDays: 'Außerordentliche Tage',
      upcomingOverrides: 'Kommender außerordentlicher Betrieb',
      noOverrides: 'Nichts geplant.',
      fixedOperation: 'Fester Betrieb',
      publicHoliday: 'Feiertag',
      extraordinary: 'Außerordentlicher Betrieb',
      closed: 'Geschlossen',
      opensAt: 'Öffnet',
      closesAt: 'Schließt',
      inOperation: 'In Betrieb',
      outOfOperation: 'Außer Betrieb',
      allDay: 'Ganztägig',
      reason: 'Grund',
      overrideSaveError:
        'Der außerordentliche Betrieb konnte nicht gespeichert werden.',
      overrideDeleteError: 'Löschen nicht möglich.',
      columns: {
        name: 'Name',
        building: 'Gebäude',
        zones: 'Zonen',
        validity: 'Gültigkeit',
        hoursPerWeek: 'Std./Woche',
      },
      weekdays: {
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'So',
      },
    },
    controlStrategy: {
      list: {
        header: 'Steuerungsstrategien',
        addButton: 'Strategie hinzufügen',
        emptyState: 'Keine Steuerungsstrategien gefunden.',
        searchPlaceholder: 'Nach Gebäude suchen...',
      },
      feedback: {
        saveSuccess: 'Steuerungsstrategie gespeichert',
        saveError: 'Fehler beim Speichern der Steuerungsstrategie',
        buildingRequired: 'Gebäude ist erforderlich',
        bothHoursRequired:
          'Beginn und Ende der Betriebszeit müssen angegeben werden',
        startBeforeEnd: 'Beginn muss vor dem Ende liegen',
        deleteSuccess: 'Steuerungsstrategie gelöscht',
        deleteError: 'Fehler beim Löschen der Steuerungsstrategie',
        confirmDeleteTitle: 'Steuerungsstrategie löschen',
        confirmDeleteMessage:
          'Möchten Sie diese Steuerungsstrategie wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
      },
      schedule: 'Betriebszeiten',
      timezone: 'Zeitzone',
      startHour: 'Betriebszeit Beginn',
      endHour: 'Betriebszeit Ende',
      actions: 'Aktionen',
      coolingLevel: 'Kühlstufe',
      heatingLevel: 'Heizstufe',
      businessHoursControl: 'Steuerung während der Geschäftszeiten',
      afterHoursControl: 'Steuerung außerhalb der Geschäftszeiten',
      controlOutsideBusinessHours: 'Außerhalb der Geschäftszeiten steuern',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp max (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ max (ppm)',
      actionLabels: {
        cool: 'Kühlen',
        heat: 'Heizen',
        preCool: 'Vorkühlen',
        preHeat: 'Vorheizen',
        ventilate: 'Belüften',
        dehumidify: 'Entfeuchten',
      },
      closed: 'Geschlossen',
      afterHoursActions: 'Aktionen außerhalb der Betriebszeit',
    },

    baseline: {
      updated: 'Aktualisiert',
      title: 'Basislinie',
      searchPlaceholder: 'Nach Basislinie suchen...',
      addButtonLabel: 'Neue Basislinie erstellen',
      confirmDeleteTitle: 'Basislinie löschen',
      confirmDeleteMessage: 'Möchten Sie diese Basislinie wirklich löschen?',
      noBaselines: 'Keine Basislinien gefunden. Erstellen Sie eine neue.',
      createNewBaselineConfirm:
        'Neue Basislinie erstellen? Dies überschreibt die bestehende.',
      editBaseline: 'Basislinie bearbeiten für',
      calculateBaseline: 'Basislinie berechnen',
      baselineChart: 'Basisliniendiagramm',
      monthsCovered: 'Abgedeckte Monate',
      excludeMonths: 'Monate ausschließen',
      pendingChanges:
        'Ungespeicherte Änderungen. Klicken Sie auf Speichern, um die Basislinie zu aktualisieren.',
      clickMonthsToExclude: `Klicken Sie auf Monate, um sie von der Basislinie auszuschließen. Orangefarbene Monate weisen eine Abweichung von 20 % oder mehr von der Basislinie auf.`,
      year: 'Jahr',
      month: 'Monat',
      energyType: 'Energieart',
      monthlySummary: 'Monatliche Zusammenfassung',
      weeklySummary: 'Wöchentliche Zusammenfassung',
      week: 'Woche',
      summary: 'Zusammenfassung',
      excluded: 'Von der Basislinie ausgeschlossen',
      energyTypes: {
        electricity: 'Elektrizität',
        districtHeating: 'Fernwärme',
        fuel: 'Brennstoff',
      },
      overBaseline: 'Über der Basislinie',
      underBaseline: 'Unter der Basislinie',
      included: 'In der Basislinie enthalten',
      activeLabel: 'Aktiv',
      inactiveLabel: 'Inaktiv',
      createdAt: 'Erstellt',
      lockTooltip: {
        locked: 'Gesperrt — klicken, um Änderungen zuzulassen',
        unlocked: 'Sperren, um Änderungen zu verhindern',
      },
      description: 'Basislinien erstellen und konfigurieren',
      backButtonLabel: 'Zurück zu den Basislinien',
    },

    home: {
      title: 'Unternehmens-Dashboard',
      tagline:
        'Verwalten Sie Einstellungen, Benutzer, Geräte und Designs an einem Ort',
    },

    dashboardItems: {
      themes: {
        title: 'Designs',
        description: 'Erstellen und verwalten Sie Farbschemata',
        linkText: 'Designs anzeigen',
      },
      users: {
        title: 'Benutzer',
        description: 'Benutzerkonten und Berechtigungen verwalten',
        linkText: 'Benutzer anzeigen',
      },
      eosDevices: {
        title: 'EOS-Geräte',
        description: 'Energie-Sensoren überwachen und verwalten',
        linkText: 'EOS-Geräte anzeigen',
      },
      settings: {
        title: 'Einstellungen',
        description: 'Systemweite Einstellungen konfigurieren',
        linkText: 'Einstellungen anzeigen',
      },
      devices: {
        title: 'Geräte',
        description: 'Verbundene Geräte konfigurieren und überwachen',
        linkText: 'Geräte anzeigen',
      },
      fileCloud: {
        title: 'Datei-Cloud',
        description: 'Dateien sicher speichern, organisieren und teilen',
        linkText: 'Dateien anzeigen',
      },
      integration: {
        title: 'API-Integrationen',
        description: 'API-Verbindungen konfigurieren und verwalten',
        linkText: 'Integrationen anzeigen',
      },
      categories: {
        title: 'Kategorien',
        description: 'Gerätekategorien erstellen und verwalten',
        linkText: 'Kategorien anzeigen',
      },
    },

    topics: {
      addButton: 'Thema hinzufügen',
      eosName: 'EOS-Name',
      sensorTag: 'Sensor-Tag',
      sensorTagRequired: 'Sensor-Tag ist erforderlich',
      sensorTagTooShort: 'Sensor-Tag muss mindestens 3 Zeichen lang sein',
      assignedTo: 'Verwendet von',
      aggregator: {
        title: 'Aggregator',
        sum: 'Summe',
        average: 'Durchschnitt',
        max: 'Max',
        min: 'Min',
        cumulative: 'Kumulativ',
        differential: 'Differenziell',
        last: 'Letzter',
      },
      scale: 'Skalierung',
      decimals: 'Dezimalstellen',
      units: 'Einheiten',
      removeButton: 'Entfernen',
      deleteTopic: 'Thema löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie dieses Thema löschen möchten?',
    },

    devices: {
      installNetmoreButton: 'Netmore-Gerät installieren',
      gatewayInstaller: 'Netmore Gateway-Installer',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'ChirpStack-Gerät installieren',
      serialNumber: 'Seriennummer',
      bulkSerialsLabel:
        'Seriennummern (durch Komma oder Zeilenumbruch getrennt)',
      ui: {
        singleModeTitle: 'Einzelnes Gerät',
        bulkModeTitle: 'Masseninstallation',
        bulkNameHintLine1:
          'Name ist leer -> Seriennummern werden als Namen verwendet',
        bulkNameHintLine2:
          'Name ist gesetzt -> alle Geräte verwenden denselben Namen',
      },
      visualToggle: {
        visualToggleDevice: 'Visual Toggle Gerät',
        visualToggleBuilding: 'Gebäude',
        visualToggleDelimiter: 'Trennzeichen',
        visualToggleDataKey: 'Daten-Schlüssel',
        visualToggleProperty: 'Eigenschaft',
        visualTogglePropertyId: 'Eigenschafts-ID',
        visualToggleValue: 'Wert',
        visualToggleColor: 'Farbe',
        visualToggleTriggers: 'Auslöser',
        visualToggleAddTrigger: 'Auslöser hinzufügen',
        visualToggleRemove: 'Auslöser entfernen',
        visualToggleSelectBuilding: 'Gebäude auswählen',
        visualToggleSelectValue: 'Wert auswählen',
        visualToggleDev: 'Gerät',
        visualToggleOverview: 'Übersicht der Visual Toggle Geräte',
        visualToggleAdd: 'Visual Toggle Gerät hinzufügen',
        visualToggleGlobalModels: 'Globale 3D-Modelle',
        visualToggleDelete: 'Visual Toggle Gerät löschen',
        visualToggleNoDevices: 'Keine Visual Toggle Geräte gefunden.',
        visualToggleSearchPlaceholder: 'Visual Toggle Geräte suchen...',
        visualToggleName: 'Name',
        visualToggleTechnicalRoom: 'Technikraum',
        visualToggleSelectRoom: 'Technikraum auswählen',
        visualToggleBuildingRequired: 'Gebäude ist erforderlich',
        visualToggleTechnicalRoomRequired: 'Technikraum ist erforderlich',
        visualToggleDeviceRequired: 'Gerät ist erforderlich',
        visualtoggleAxes: {
          xAxis: 'Rotation X',
          yAxis: 'Rotation Y',
          zAxis: 'Rotation Z',
          off: 'Aus',
          half: 'Halb',
          full: 'Voll',
          none: 'Keine',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Möchten Sie dieses Visual Toggle Gerät wirklich löschen?',
          visualToggleDeleteSuccess: 'Visual Toggle Gerät erfolgreich gelöscht',
          visualToggleDeleteError:
            'Beim Löschen des Visual Toggle Geräts ist ein Fehler aufgetreten',
          visualToggleDataKey: 'Fehlender Daten-Schlüssel',
          visualToggleTrigger: 'Fehlender Auslöser',
          visualToggleProperty: 'Eigenschaft ist erforderlich.',
          visualToggleValue: 'Wert ist erforderlich.',
          visualToggleUpdated: 'Visual Toggle Gerät erfolgreich aktualisiert',
          visualToggleCreated: 'Visual Toggle Gerät erfolgreich erstellt',
          visualToggleSaveError:
            'Beim Speichern des Visual Toggle Geräts ist ein Fehler aufgetreten',
        },
      },
      list: {
        header: 'Geräteverwaltung',
        addButton: 'Gerät hinzufügen',
        emptyState: 'Keine Geräte gefunden.',
        searchPlaceholder: 'Geräte suchen…',
        backButton: 'Zurück zu Geräten',
      },
      validation: {
        nameRequired: 'Gerätename ist erforderlich',
        sensorTagMissing: 'Sensor-Tag fehlt für Thema {{index}}.',
        sensorTagTooShort:
          'Sensor-Tag für Thema {{index}} muss mindestens 3 Zeichen lang sein.',
      },
      feedback: {
        updateSuccess: 'Gerät erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren des Geräts',
        createSuccess: 'Gerät erfolgreich erstellt',
        installSuccess: 'Gerät erfolgreich installiert',
        createError: 'Fehler beim Erstellen des Geräts',
        duplicateDevice: 'Ein Gerät mit dieser Seriennummer existiert bereits.',
        saveError: 'Fehler beim Speichern des Geräts',
        missingAttributes:
          'Wir benötigen alle erforderlichen Felder, die ausgefüllt werden müssen',
        validationError: 'Validierungsfehler',
        serviceUnavailable:
          'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
        bulkInstallSummary:
          'Installiert: {installed}. Duplikate: {duplicates}. Fehlgeschlagen: {failed}.',
      },
      deviceControls: {
        title: 'Gerätesteuerung',
        send: 'Senden',
        updateSuccessMessage: 'Setpoint erfolgreich aktualisiert',
        updateSuccessTitle: 'Erfolg',
        updateErrorTitle: 'Fehler',
        updateErrorMessage: 'Setpoint konnte nicht aktualisiert werden',
        hideAdvanced: 'Erweiterte Optionen ausblenden',
        showAdvanced: 'Erweiterte Optionen anzeigen ({count} Geräte)',
        current: 'Wert',
        range: 'Von',
        duration: 'Dauer (Stunden)',
        durationHelp: 'Danach kehrt der Sollwert zum Zeitplan zurück',
        comment: 'Kommentar',
        commentPlaceholder: 'Warum wird dies überschrieben?',
        notLogged:
          'Sollwert gesetzt, aber die Überschreibung konnte nicht protokolliert werden',
      },
    },

    eosDevices: {
      energyCategories: {
        electricityGrid: 'Strom (Netz)',
        electricityGridExport: 'Eingespeister Strom (Netz)',
        districtHeating: 'Fernwärme',
        districtCooling: 'Fernkälte',
        fossilFuels: 'Fossile Brennstoffe',
        biofuels: 'Biobrennstoffe',
        solarPV: 'Photovoltaik',
        solarThermal: 'Solarthermie',
        otherRenewables: 'Andere erneuerbare Energien (Wind, Geothermie)',
        wasteHeat: 'Abwärme',
      },
      list: {
        header: 'EOS-Geräte',
      },
      validation: {
        sensorTagMissing: 'Sensor-Tag fehlt für Thema {{index}}.',
        sensorTagTooShort:
          'Sensor-Tag für Thema {{index}} muss mindestens 3 Zeichen lang sein.',
      },
      feedback: {
        updateSuccess: 'Gerät erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren des Geräts',
        createSuccess: 'Gerät erfolgreich erstellt',
        createError: 'Fehler beim Erstellen des Geräts',
        saveError: 'Fehler beim Speichern des Geräts',
      },
    },

    editDevice: {
      newTitle: 'Neues Gerät',
      deviceName: 'Gerätename',
      deviceDescription: 'Gerätebeschreibung',
      deviceProfile: 'Geräteprofil',
      selectDeviceProfile: '- Geräteprofil wählen',
      setpointRange: 'Setpunktbereich',
      setpointRangeInfo:
        'Legen Sie den oberen und unteren Setpunkt für das Sensor-Tag fest, sowie die Schrittgröße zwischen den Setpunkten.',
      minSetpoint: 'Niedriger Setpunkt',
      maxSetpoint: 'Höher Setpunkt',
      stepSize: 'Schrittgröße',
      controlMode: {
        label: 'Steuermodus',
        info: 'Bestimmt, wie das Gerät geregelt wird, wenn die Steuerung ausgelöst wird.\nSchritt: Passt den Setpunkt schrittweise um die Schrittgröße pro Durchlauf nach oben/unten an, innerhalb von Min/Max.\nBinär: Springt direkt auf Max (mehr Heizung/Lüftung) oder Min (weniger). Ein/Aus-Steuerung.\nZeitplan: Folgt nur den Öffnungszeiten — Max innerhalb, Min außerhalb. Ignoriert ASPA-Aktionen.\nSetpunkt: Schreibt den gewünschten Setpunkt direkt, begrenzt auf Min/Max. Aktualisiert nur bei Abweichung über ±0,1.',
        step: 'Schritt',
        binary: 'Binär',
        schedule: 'Zeitplan',
        setpoint: 'Setpunkt',
      },
      operatingHoursOnly: 'Nur innerhalb der Betriebszeit steuern',
      dynamicSetpoints: {
        label: 'Dynamische Setpunkte',
        info: 'Dynamische Setpunkte erlauben es dem Gerät, seinen Setpunktbereich basierend auf anderen Sensorwerten zu überschreiben. Wenn der Sensorwert im Sensor-Tag die Bedingung (Operator + Schwellenwert) erfüllt, werden niedriger Setpunkt, höherer Setpunkt und Schrittgröße dieses Eintrags anstelle des normalen Setpunktbereichs des Geräts verwendet.\nSensor-Tag: das überwachte Sensor-Tag (z. B. Ansteuerung des Kühlregisters).\nOperator/Schwellenwert: die Bedingung, die erfüllt sein muss, damit die Überschreibung aktiv ist.\nNiedriger/höherer Setpunkt und Schrittgröße: der Setpunktbereich, der gilt, solange die Bedingung erfüllt ist.',
        add: 'Dynamischen Setpunkt hinzufügen',
        deleteTitle: 'Dynamischen Setpunkt entfernen',
        confirmDelete:
          'Möchten Sie diesen dynamischen Setpunkt wirklich entfernen?',
        operator: 'Operator',
        threshold: 'Schwellenwert',
        validationError:
          'Alle Felder müssen ausgefüllt sein, um einen dynamischen Setpunkt hinzuzufügen.',
        fieldRequired: 'Erforderlich',
      },
      controllerSettings: 'Controller-Einstellungen',
      status: {
        active: 'Aktiv',
        displayInZone: 'In Zone anzeigen',
      },
      display: 'Anzeige',
      icon: 'Symbol',
      deviceType: {
        label: 'Gerätetyp',
        selectDefault: '- Gerätetyp wählen',
        sensor: 'Sensor',
        controller: 'Controller',
      },
      dataReceiver: {
        label: 'Datenempfänger',
        selectDefault: '- Datenempfänger wählen',
        info: 'Legen Sie fest, welcher Empfänger die Steuerwerte für dieses Gerät erhalten soll.',
      },
      deviceCategory: {
        label: 'Gerätekategorie',
        selectDefault: 'Kategorie wählen',
      },
      valueMap: 'Gerätewerte in Text umwandeln (optional)',
      setValueMapping: 'Wertzuordnung festlegen',
      mappedAttribute: {
        label: 'Zuordnung des Attributs',
        attribute: 'Attribut',
        numberValue: 'Nummer',
        textValue: 'Text',
        duplicateValueMapping: 'Dieser Wert ist bereits vorhanden!',
        cancelEditValueMapping: 'Abbrechen',
        removeValueMapping: 'Entfernen',
        editValueMapping: 'Bearbeiten',
        deleteTitle: 'Wertzuordnung löschen',
        confirmDeleteValueMapping:
          'Möchten Sie diese Wertzuordnung wirklich löschen?',
        confirmDeleteMappedAttributeTitle: 'Kartiertes Attribut löschen',
        confirmDeleteMappedAttribute:
          'Möchten Sie dieses kartierte Attribut wirklich löschen?',
      },
      topics: 'Themen',
      inspectDevice: 'Gerät prüfen',
      deleteButton: {
        deleting: 'Lösche…',
        label: 'Gerät löschen',
      },
      confirmDelete: 'Möchten Sie dieses Gerät wirklich löschen?',
      title: 'Gerät bearbeiten',
    },

    editEosDevice: {
      title: 'EOS-Gerät bearbeiten',
      newTitle: 'Neues EOS-Gerät',
      deviceName: 'Gerätename',
      topics: 'Themen',
      deviceDescription: 'Gerätebeschreibung',
      active: 'Aktiv',
      producingPower: 'Erzeugte Leistung',
      includeInBaseline: 'In Baseline einbeziehen',
      deviceSettings: 'Geräteeinstellungen',
      energyCategory: { label: 'Energiekategorie' },
      provider: {
        label: 'Anbieter',
        required: 'Für Fernwärme ist ein Anbieter erforderlich',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Gebäude',
      allBuildings: 'Alle Gebäude',
      sensorTypes: {
        HEAT: 'Heizung',
        LIGHT: 'Licht',
        HVAC: 'HVAC',
        PRODUCTION: 'Produktion',
        OFFICE: 'Büro',
        OTHER: 'Sonstiges',
      },
      icon: 'Symbol',
      deviceType: {
        label: 'Gerätetyp',
        selectDefault: '- Gerätetyp wählen',
        eosSensor: 'EOS-Sensor',
        eosSource: 'EOS-Quelle',
      },
      sensorConfiguration: 'Sensorkonfiguration',
      deviceCategory: {
        label: 'Gerätekategorie',
        selectDefault: 'Kategorie wählen',
      },
      sources: 'Quellen',
      inspectDevice: 'Gerät prüfen',
      deleteButton: {
        deleting: 'Lösche…',
        label: 'EOS-Gerät löschen',
      },
      confirmDelete: 'Möchten Sie dieses Gerät wirklich löschen?',
    },

    categories: {
      list: {
        header: 'Kategorien',
        addButton: 'Kategorie hinzufügen',
        emptyState: 'Keine Kategorien gefunden.',
        searchPlaceholder: 'Kategorien suchen…',
        backButton: 'Zurück zu Kategorien',
      },
      feedback: {
        updateSuccess: 'Kategorie erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren der Kategorie',
        createSuccess: 'Kategorie erfolgreich erstellt',
        createError: 'Fehler beim Erstellen der Kategorie',
        saveError: 'Fehler beim Speichern der Kategorie',
      },
    },

    editCategory: {
      parentCategory: 'Übergeordnete Kategorie',
      legend: 'Sprache',
      categoryName: 'Kategoriename:',
      languageType: 'Sprachtyp:',
      selectLanguage: 'Sprache wählen',
      categoryDescription: 'Kategoriebeschreibung:',
      deleteCategory: 'Kategorie löschen',
      deleteConfirm: 'Möchten Sie diese Kategorie wirklich löschen?',
      categoryType: 'Kategorietyp',
      validation: {
        categoryRequired: 'Mindestens ein Kategorietyp ist erforderlich',
        languageRequired: 'Sprache ist erforderlich',
      },
      languageOptions: {
        en: 'Englisch',
        no: 'Norwegisch',
        se: 'Schwedisch',
        de: 'Deutsch',
        fr: 'Französisch',
        es: 'Spanisch',
      },
      categoryTypes: {
        device: 'Gerät',
        zone: 'Zone',
        service: 'Dienst',
        resource: 'Ressource',
        activity: 'Aktivität',
      },
    },

    userManagement: {
      auditLogs: {
        viewed: 'Angesehen',
        doneBy: 'Durchgeführt von',
        noAccess:
          'Sie benötigen Stufe 4 (Systemadministrator) oder höher, um Audit-Logs zu sehen.',
      },
      auditChanges: {
        readQuery: 'Was gelesen wurde',
        title: 'Was wurde geändert',
        field: 'Feld',
        before: 'Vorher',
        after: 'Nachher',
        created: 'Erstellt',
        updated: 'Aktualisiert',
        deleted: 'Gelöscht',
        empty: 'Für diese Anfrage wurden keine Datenbankänderungen erfasst.',
        more: 'Es wurden mehr Datensätze geändert, als hier angezeigt werden.',
        hidden: 'Verborgen',
        largeValue: 'Großer Wert',
        items: 'Einträge',
        sentData: 'Gesendete Daten',
      },
      list: {
        header: 'Benutzerverwaltung',
        addButton: 'Benutzer hinzufügen',
        emptyState: 'Keine Benutzer gefunden.',
        searchPlaceholder: 'Benutzer suchen…',
        backButton: 'Zurück zu Benutzern',
      },
      feedback: {
        fetchError: 'Fehler beim Laden der Benutzer',
        updateSuccess: 'Benutzer erfolgreich aktualisiert',
        updateError: 'Fehler beim Aktualisieren des Benutzers',
        createSuccess: 'Benutzer erfolgreich erstellt',
        createError: 'Fehler beim Erstellen des Benutzers',
        saveError: 'Fehler beim Speichern des Benutzers',
      },
    },

    editUser: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      userInformation: 'Benutzerinformationen',
      mobileNumber: 'Handynummer',
      email: 'E-Mail',
      password: 'Passwort',
      enovaOrganization: 'Organisation',
      enovaOrganizationNumber: 'Organisationsnummer',
      enovaPersonalGuid: 'Enova-GUID',
      azureAccount: 'Azure-Tenant-ID',
      role: 'Rolle',
      active: 'Aktiv',
      acceptEmails: 'E-Mails akzeptieren',
      receiveEmails: 'Benutzer erhält System-E-Mails',
      canLogin: 'Benutzer kann sich anmelden und auf das System zugreifen',
      hideFeedback: 'Feedback ausblenden',
      hidePopups: 'Feedback-Pop-ups ausblenden',
      changePassword: 'Passwort ändern',
      successUpdatePassword: 'Passwort erfolgreich geändert',
      errorUpdatePassword: 'Passwort konnte nicht geändert werden',
      passwordFeedback: 'Passwort muss mindestens 8 Zeichen lang sein',
      addNew: 'Neuen Benutzer hinzufügen',
      calendarSetup: 'Kalendereinrichtung',
      calendarStartOfDay: 'Tagesbeginn (für Kalenderansicht)',
      calendarEndOfDay: 'Tagesende',
      tenantAccess: {
        header: 'Mandantenzugriff',
        label: 'Mandant',
        addAccess: 'Zugriff hinzufügen',
        selectTenant: '- Mandant wählen -',
        assignedTenants: 'Zugewiesene Mandanten',
        fetchFailed: 'Mandanten konnten nicht geladen werden',
        feedback: {
          pleaseSelect: 'Bitte wählen Sie einen Mandanten',
          alreadyAdded: 'Mandant bereits hinzugefügt',
        },
      },
      deleteUser: {
        label: 'Benutzer löschen',
        deleting: 'Lösche…',
      },
      confirmDelete: 'Möchten Sie diesen Benutzer wirklich löschen?',
      activityLog: 'Aktivitätsprotokoll',
    },

    integrationOverview: {
      edit: {
        details: {
          legend: 'Details',
          nameLabel: 'Name',
          activeLabel: 'Aktiv',
        },
        access: {
          legend: 'Zugriff',
          accessLevelLabel: 'Zugriffsebene',
          dateFromLabel: 'Datum von',
          dateToLabel: 'Datum bis',
          accessLevelOptions: {
            noAccess: 'Kein Zugriff',
            readOnly: 'Nur lesen',
            readAndWrite: 'Lesen und schreiben',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Schlüssel',
          revealButton: 'Anzeigen',
          publicKeyLabel: 'Öffentlicher Schlüssel',
          secretKeyLabel: 'Geheimer Schlüssel',
        },
      },
      feedback: {
        updateSuccess: 'Integration aktualisiert',
        createSuccess: 'Integration erstellt',
        saveError: 'Speichern fehlgeschlagen',
        fetchSecretsError: 'Schlüssel konnten nicht abgerufen werden',
        fetchIntegrationsError: 'Integrationen konnten nicht abgerufen werden',
      },
    },

    themeSettings: {
      header: {
        title: 'Designs',
        subtitle:
          'Erstellen und verwalten Sie die visuellen Designs für Ihr Unternehmen',
      },
      feedback: {
        activatedSuccess: 'Design {themeName} erfolgreich aktiviert',
        deletedSuccess: 'Design gelöscht',
        updatedSuccess: 'Design aktualisiert',
        createdSuccess: 'Design erstellt',
      },
      card: {
        customize: 'Anpassen',
        fallbackDescription: 'Ein {name}-Design',
        confirmDelete: 'Möchten Sie das Design „{name}" wirklich löschen?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Sonnenuntergang-Orange',
          description: 'Warme Orange- und Korallentöne mit sandigen Akzenten',
        },
        oceanBlue: {
          name: 'Ozeanblau',
          description: 'Erfrischende Blautöne, inspiriert vom Ozean',
        },
        crimsonRed: {
          name: 'Karminrot',
          description: 'Kraftvolles Karmin mit energischen Rottönen',
        },
        forestGreen: {
          name: 'Waldgrün',
          description: 'Beruhigende Waldgrüntöne mit natürlichen Akzenten',
        },
        blackAndWhite: {
          name: 'Schwarz & Weiß',
          description:
            'Zeitloser Schwarz-Weiß-Kontrast für einen modernen Look',
        },
        classicGray: {
          name: 'Klassisches Grau',
          description: 'Professionelles graues Design mit subtilen Kontrasten',
        },
        modernWhite: {
          name: 'Modernes Weiß',
          description:
            'Zeitloses Weiß für eine saubere, minimalistische Ästhetik',
        },
      },
      dialog: {
        editHeader: 'Design bearbeiten',
        createHeader: 'Design erstellen',
        createTitle: 'Neues Design erstellen',
        createDescription:
          'Erstellen Sie ein benutzerdefiniertes Design mit Ihren Farben und Stilen',
        namePlaceholder: 'Name Ihres Designs',
        descriptionPlaceholder: 'Beschreiben Sie Ihr Design (optional)',
        iconHover: 'Symbol Hover',
        nameRequired: 'Designname ist erforderlich',
        customSuffix: '(Benutzerdefiniert)',
      },
    },

    vendor: {
      title: 'Allgemein',
      form: {
        name: 'Name',
        contactDetails: 'Kontaktdaten',
        street: 'Straße',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        country: 'Land',
        timezone: 'Zeitzone',
        selectTimezone: 'Zeitzone festlegen',
        organizationNumber: 'Org.-Nr.',
        phone: 'Telefon',
        email: 'Kontakt-E-Mail',
        website: 'Link zur Unternehmenswebsite',
        languageDefault: 'Standardsprache',
        selectLanguage: 'Sprache festlegen',
      },
      modules: {
        title: 'Module',
        threeDView: '3D-Ansicht',

        requiredAttributes: {
          title: 'Erforderliche Attribute',
          firstName: 'Vorname',
          lastName: 'Nachname',
          phone: 'Telefon',
          email: 'E-Mail',
        },
        buildingAutomation: {
          title: 'Gebäudeautomation',
          sastechTenantId: 'Sastech-Tenant-ID',
          ignitionProjectName: 'Ignition-Projektname',
          gridRegion: 'Netzregion',
          selectGridRegion: '- Gebiet wählen -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Public Display',
          loginToDisplay: 'Für Display anmelden',
          invalidPassword: 'Ungültiges Passwort. Bitte erneut versuchen.',
          password: 'Passwort',
          publicLink: 'Public-Display-Link:',
          description:
            'Wichtige Gebäudekennzahlen auf einem öffentlichen Bildschirm ohne UI anzeigen',
          placeholder: 'Neues Passwort eingeben',
          leaveBlankHint:
            'Leer lassen, um das aktuelle Passwort beizubehalten.',
          copyButton: 'Kopieren',
          copySuccess: 'Link in die Zwischenablage kopiert',
          saveVendorFirst:
            'Bitte speichern Sie den Anbieter, um ein Token zu erzeugen',
          regenerateButton: 'Token erneuern',
          regenerateWarning:
            'Warnung: Dadurch wird der bestehende Link ungültig',
          confirmRegenerate:
            'Möchten Sie das Token wirklich erneuern? Der bestehende Link wird dadurch ungültig.',
          tokenRegenerated: 'Token erfolgreich erneuert',
          tokenRegenerateFailed: 'Token konnte nicht erneuert werden',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Datenschutz und Anonymisierung',
        activateAnonymizing: 'Anonymisierung aktivieren',
        privacyPolicyText:
          'Hier legen Sie das Intervall für die Anonymisierung fest',
        monthsToKeepData: 'Aufbewahrungsdauer der Daten (Monate)',
      },
      keyAccountManager: {
        title: 'Key Account Manager',
        notAssigned: 'Nicht zugewiesen',
      },
      tenantStatus: {
        title: 'Mandantenstatus',
        tenantIsActive: 'Mandant ist aktiv',
        status: 'Status',
        options: {
          development: '1. Entwicklung',
          readyForProduction: '2. Produktionsbereit',
          production: '3. Produktion (Systemwert)',
          deleted: 'Gelöscht',
        },
        markedForDeletion: 'Zur Löschung markiert',
        vendorDeletionTitle: 'Anbieter-Löschung',
        vendorDeletionDescription:
          'Der Anbieter wird nur gelöscht, wenn er zur Löschung markiert, der Mandantenstatus auf "gelöscht" gesetzt und der Anbieter inaktiv ist. Zudem muss das Modell seit mehr als 30 Tagen nicht aktualisiert worden sein.',
      },
      vendorIdLabel: 'Anbieter-ID',
      successMessage: 'Anbieter erfolgreich aktualisiert',
      successMessagePassword:
        'Anbieter erfolgreich aktualisiert (Passwort geändert)',
      errorMessage: 'Anbieter konnte nicht aktualisiert werden',
    },
    /* ─────────────── IMAGE / FILE UPLOAD (excerpt) ──────────────── */
    imageUpload: {
      uploadImage: 'Bild hochladen',
      noFileSelected: 'Keine Datei ausgewählt',
      uploading: 'Wird hochgeladen …',
      fileSizeExceeded: 'Dateigröße überschreitet das Limit von {{size}} MB.',
      invalidFileType: 'Ungültiger Dateityp. Bitte ein Bild wählen.',
      uploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen',
      bytes: 'Byte',
      dropToReplace: 'Bild ablegen zum Ersetzen',
      dragHint: 'Hierher ziehen und ablegen zum Ersetzen',
      fromFileCloud: 'Datei-Cloud',
      chooseFromFileCloud: 'Aus Datei-Cloud auswählen',
      convertingHeic: 'HEIC-Bild wird konvertiert …',
      heicConversionFailed:
        'HEIC-Bild konnte nicht konvertiert werden. Bitte stattdessen JPEG oder PNG verwenden.',
      uploadProgress: 'Lade {{done}} von {{total}} hoch …',
      uploadFailedFiles: 'Konnte nicht hochgeladen werden: {{names}}',
    },

    fileUpload: {
      uploadImage: 'Datei hochladen',
      noFileSelected: 'Keine Datei ausgewählt',
      uploading: 'Wird hochgeladen …',
      fileSizeExceeded: 'Dateigröße überschreitet das Limit von {{size}} MB.',
      invalidFileType: 'Ungültiger Dateityp. Bitte eine gültige Datei wählen.',
      uploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen',
      fileAlreadyUploaded: 'Datei bereits hochgeladen',
      uploadFile: 'Datei hochladen',
      viewUploadedFile: 'Hochgeladene Datei anzeigen',
      uploadNewFile: 'Neue Datei hochladen',
      fileLabel: 'Datei:',
      sizeLabel: 'Größe:',
    },

    /* ────────────── FILE CLOUD (excerpt) ───────────────────────── */
    fileCloud: {
      title: 'Datei-Cloud',
      storageTitle: 'Lagerung',
      nameLabel: 'Name',
      folderLabel: 'Ordner',
      sizeLabel: 'Größe',
      dateLabel: 'Datum',
      buildingLabel: 'Gebäude',
      currentPath: 'Aktueller Pfad',
      rootLabel: 'Start',
      selectedLabel: 'ausgewählt',
      gridViewLabel: 'Rasteransicht',
      listViewLabel: 'Listenansicht',
      header:
        'Dateien sicher speichern, organisieren und unternehmensweit teilen',
      uploadFiles: {
        dropZonePrompt: 'Dateien hierher ziehen und ablegen',
        selectedFilesHeader: 'Ausgewählte Dateien:',
        uploadButton: 'Hochladen',
        uploadFilesLabel: 'Dateien hochladen',
        uploadFolderLabel: 'Ordner hochladen',
        uploadProgress: 'Lade {{done}} von {{total}} Dateien hoch …',
      },
      noFiles: 'Dateien ziehen & ablegen',
      noBuildings: 'Keine Gebäude vorhanden.',
      menu: {
        download: 'Herunterladen',
        rename: 'Umbenennen',
        delete: 'Löschen',
        setBuilding: 'Gebäude zuordnen',
        clearBuilding: 'Gebäudezuordnung löschen',
      },
      dialog: {
        buildingTitle: 'Gebäude wählen',
        cancelButton: 'Abbrechen',
        newFolderName: 'Ordnername',
        createFolder: 'Ordner erstellen',
        renameFolder: 'Ordner umbenennen',
        confirmDeleteTitle: 'Löschen bestätigen',
        confirmDeleteMessage:
          'Sind Sie sicher, dass Sie die ausgewählte Datei löschen möchten?',
        confirmFolderDeleteMessage:
          'Sind Sie sicher, dass Sie den ausgewählten Ordner und seinen gesamten Inhalt löschen möchten?',
        invalidFolderName:
          'Der Ordnername enthält ungültige Zeichen oder ist leer.',
        duplicateFolderName: 'Ein Ordner mit diesem Namen existiert bereits.',
        confirmDeleteSelectedMessage:
          'Möchten Sie die ausgewählten Dateien wirklich löschen?',
      },
      feedback: {
        // existing
        fileDeleted: 'Datei erfolgreich gelöscht',
        buildingCleared: 'Gebäude erfolgreich geleert',
        buildingAssigned: 'Gebäude erfolgreich zugewiesen',
        buildingUpdateError:
          'Die Gebäudeverknüpfung konnte nicht aktualisiert werden.',

        // Restore file
        fileRestored: 'Datei erfolgreich wiederhergestellt.',
        restoreSuccessfulTitle: 'Wiederherstellung erfolgreich',
        restoreErrorMessage: 'Datei konnte nicht wiederhergestellt werden.',
        restoreErrorTitle: 'Wiederherstellungsfehler',

        // Empty garbage
        garbageEmptied: 'Papierkorb erfolgreich geleert.',
        emptyGarbageSuccessfulTitle: 'Papierkorb erfolgreich geleert',
        emptyGarbageErrorMessage: 'Papierkorb konnte nicht geleert werden.',
        emptyGarbageErrorTitle: 'Fehler beim Leeren des Papierkorbs',

        // Move folder to garbage
        folderMovedToGarbage:
          'Ordner erfolgreich in den Papierkorb verschoben.',
        moveFolderToGarbageSuccessfulTitle:
          'In den Papierkorb verschieben erfolgreich',
        moveFolderToGarbageErrorMessage:
          'Ordner konnte nicht in den Papierkorb verschoben werden.',
        moveFolderToGarbageErrorTitle:
          'Fehler beim Verschieben in den Papierkorb',

        // Rename folder
        folderRenamed: 'Ordner erfolgreich umbenannt.',
        renameFolderSuccessfulTitle: 'Umbenennung erfolgreich',
        renameFolderErrorMessage: 'Ordner konnte nicht umbenannt werden.',
        renameFolderErrorTitle: 'Umbenennungsfehler',

        // Move folder
        folderMoved: 'Ordner erfolgreich verschoben.',
        moveFolderSuccessfulTitle: 'Verschieben erfolgreich',
        moveFolderErrorMessage: 'Ordner konnte nicht verschoben werden.',
        moveFolderErrorTitle: 'Fehler beim Verschieben',

        // Delete file
        deleteSuccessfulTitle: 'Löschen erfolgreich',
        deleteErrorMessage: 'Datei konnte nicht gelöscht werden.',
        deleteErrorTitle: 'Löschfehler',

        // Move file
        moveFileErrorMessage: 'Datei konnte nicht verschoben werden.',
        moveFileErrorTitle: 'Verschiebefehler',

        // Create folder
        createFolderErrorMessage: 'Ordner konnte nicht erstellt werden.',
        createFolderErrorTitle: 'Fehler beim Erstellen des Ordners',

        // Upload
        uploadSuccessfulMessage: 'Dateien erfolgreich hochgeladen.',
        uploadSuccessfulTitle: 'Upload erfolgreich',
        uploadErrorTitle: 'Upload-Fehler',
      },

      newFolder: 'Neuer Ordner',
      confirmDeleteFolder:
        'Sind Sie sicher, dass Sie diesen Ordner und seinen gesamten Inhalt löschen möchten?',
      moveToRoot: 'In das Stammverzeichnis verschieben',
    },
    feedback: {
      vendorLoad: {
        title: 'Fehler',
        message: 'Anbieterinformationen konnten nicht geladen werden',
      },
    },
    degreeDays: {
      error: 'Das Gebäude verfügt nicht über GPS-Koordinaten',
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Feedback senden',
    close: 'Schließen',
    messageLabel: 'Nachricht',
    placeholder: 'Geben Sie hier Ihr Feedback ein…',
    screenshotTitle: 'Screenshot hochladen',
    send: 'Senden',
    infoPrefix: 'Weitere Informationen finden Sie in unserem',
    helpCenter: 'Hilfe-Center',
    statusPage: 'Statusseite',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        'Keine Gebäudeinspektion zum Löschen ausgewählt.',
      deleteConfirmMessage:
        'Sind Sie sicher, dass Sie diese Gebäudeinspektion löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteSuccessMessage: 'Die Gebäudeinspektion wurde gelöscht.',
      deleteErrorMessage: 'Die Gebäudeinspektion konnte nicht gelöscht werden.',
      updateSuccessMessage: 'Die Gebäudeinspektion wurde aktualisiert.',
      createSuccessMessage: 'Die Gebäudeinspektion wurde erstellt.',
      failedToLoadMessage:
        'Gebäudeinspektionen konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
      saveErrorMessage:
        'Die Gebäudeinspektion konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
      buildingErrorMessage:
        'Bitte wählen Sie ein Gebäude für die Gebäudeinspektion aus.',
      buildingTypeErrorMessage:
        'Bitte wählen Sie einen Gebäudetyp für die Gebäudeinspektion aus.',
      failedToLoadBuildingsMessage:
        'Gebäude konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
      calculationsCompleteMessage: 'Berechnungen abgeschlossen',
      //Header
      title: 'Gebäudeinspektion',
      subtitle:
        'Führen Sie die Gebäudeinspektion mit dem untenstehenden Formular durch',
      newInspectionLabel:
        'Neue Inspektion, speichern, um weitere Optionen zu aktivieren.',
      reportLabel: 'Bericht',
      actionsLabel: 'Maßnahmen',
      generalLabel: 'Allgemein',
      //Info
      status: {
        statusLabel: 'Status',
        draft: 'Entwurf',
        completed: 'Abgeschlossen',
        inReview: 'In Prüfung',
      },
      buildingLabel: 'Gebäude',
      buildingTypeLabel: 'Gebäudetyp (DIN-Norm)',
      notesLabel: 'Notizen',
      buildingTypes: {
        label: {
          smallHouse: 'Einfamilienhaus',
          apartmentBlock: 'Mehrfamilienhaus',
          kinderGarden: 'Kindergarten',
          officeBuilding: 'Bürogebäude',
          schoolBuilding: 'Schulgebäude',
          universityCollege: 'Universität / Hochschule',
          hospital: 'Krankenhaus',
          nursingHome: 'Pflegeheim',
          hotel: 'Hotel',
          sportsBuilding: 'Sportgebäude',
          commercialBuilding: 'Gewerbegebäude',
          culturalBuilding: 'Kulturgebäude',
          lightIndustryWarehouse: 'Leichtindustrie / Lagergebäude',
        },
        description: {
          smallHouse:
            'Einfamilienhaus, Doppelhaus, Reihenhaus, Kettenhaus oder andere kleine Wohngebäude.',
          apartmentBlock:
            'Wohngebäude mit zwei oder mehr Stockwerken, einschließlich großer Reihenhäuser mit mehreren Etagen.',
          kinderGarden:
            'Gebäude, die für Kindergärten oder frühkindliche Bildung vorgesehen sind.',
          officeBuilding:
            'Einfache Büros, Büros mit Belüftung und Kühlung oder Ausstellungs- und Kongressgebäude.',
          schoolBuilding:
            'Bildungseinrichtungen, einschließlich Schulen mit Schwimmbädern oder Sporthallen.',
          universityCollege:
            'Universitäts- oder Hochschulgebäude, Laborgebäude oder Forschungseinrichtungen.',
          hospital:
            'Krankenhäuser, Patientenhotels oder Laborgebäude für medizinische Zwecke.',
          nursingHome: 'Pflegeheime für Langzeitaufenthalte und Betreuung.',
          hotel: 'Hotels, Restaurantgebäude oder andere Beherbergungsbetriebe.',
          sportsBuilding:
            'Sporthallen, Schwimmbäder und andere Sportanlagen mit Umkleide- und Duschbereichen.',
          commercialBuilding:
            'Geschäfte, Geschäftsräume mit Kühl- oder Gefrieranlagen oder Tankstellen.',
          culturalBuilding:
            'Kinos, Museen, Bibliotheken und religiöse Gebäude.',
          lightIndustryWarehouse:
            'Industriegebäude, Lagerhäuser, Fischerei-/Landwirtschaftsgebäude, Energieanlagen oder Werkstätten.',
        },
      },
      mainTabs: {
        info: 'Informationen',
        climate: 'Klima',
        zones: 'Zonen',
        hvac: 'HLK & Betrieb',
        heatingCooling: 'Heizung & Kühlung',
        excessEnergy: 'Überschüssige Energie',
        analytics: 'Analyse',
        attachments: 'Anhänge',
      },
      footerButtons: {
        next: 'Weiter',
        previous: 'Zurück',
      },
      climate: {
        averageMonthlyTemp: 'Durchschnittliche Monatstemperatur (°C)',
        globalIrradiation: 'Globale Einstrahlung (kWh/m²)',
        diffuseIrradiation: 'Diffuse Einstrahlung (kWh/m²)',
        albedo: 'Albedo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'HLK-Anlagen',
        operationalLoads: 'Betriebslasten',
        productionEquipment: 'Produktionsanlagen',
      },
      zoneManager: {
        area: 'Fläche (m²)',
        noZonesCreatedYet: 'Es wurden noch keine Zonen erstellt',
        createZoneToBegin:
          'Erstellen Sie eine Zone, um mit der Erfassung der Daten der Gebäudehülle zu beginnen. Sie können entweder eine bestehende Gebäudezone auswählen oder eine neue speziell für diese Begehung anlegen.',
        subTabs: {
          buildingEnvelope: 'Gebäudehülle',
          windows: 'Fenster',
          doors: 'Türen',
          gates: 'Tore',
          airLeakage: 'Luftundichtigkeiten',
          thermalMass: 'Thermische Masse',
        },
        zoneSelector: {
          createFirstZone: 'Erste Zone erstellen',
          addZone: 'Zone hinzufügen',
          deleteSelectedZone: 'Ausgewählte Zone löschen',
          linked: 'Verknüpft',
        },
        zoneCreateModal: {
          zoneNameError: 'Zonenname ist erforderlich.',
          createNewZoneLabel: 'Neue Zone erstellen',
          linkExistingZoneLabel: 'Bestehende Zone verknüpfen',
          linkExistingZoneHelperText:
            'Wählen Sie eine bestehende Zone, die mit dieser Begehung verknüpft werden soll.',
          selectZonePlaceholder: 'Zone auswählen...',
          createNewZoneHelperText:
            'Erstellen Sie eine neue Zone, die dem Gebäude hinzugefügt und für diese Begehung verwendet wird.',
          zoneName: 'Zonenname',
          description: 'Beschreibung',
          cancelButtonLabel: 'Abbrechen',
          addZoneTitle: 'Zone hinzufügen',
          zoneNameLabel: 'Zonenname',
          descriptionLabel: 'Beschreibung',
        },
        exteriorWalls: 'Außenwände',
        helperWithHistory: {
          north: 'Nord',
          south: 'Süd',
          east: 'Ost',
          west: 'West',
          count: 'Anzahl',
          width: 'Breite (m)',
          height: 'Höhe (m)',
          addToArea: 'Zur Fläche hinzufügen (m²)',
          history: 'Verlauf',
          entry: ' Berechnung',
          entries: ' Berechnungen',
          inputHistory: 'Berechnungshistorie',
          helperTitle: 'Flächenrechner',
        },
        windows: {
          glassType: 'Glasstyp',
          windowTypes: [
            'Keine',
            'Einfachverglasung',
            'Zweifachverglasung',
            'Zweifach-Wärmeschutzverglasung',
            'Zweifach-Sonnenschutzverglasung',
            'Dreifach-Wärmeschutzverglasung',
          ],
          totalWindowsArea: 'Gesamtfensterfläche (m²)',
          sumOfAllWindowsSurfaces: 'Summe aller Fensterflächen',
          averageUValue: 'Mittlerer U-Wert (W/m²K)',
          averageUValueFormula: '(Σ(U × Fläche)) / Σ(Fläche)',
          winAreaAsPercentageOfFacade: 'Fensterfläche in % der Fassade',
          winAreaAsPercentageOfFacadeFormula:
            'Gesamtfensterfläche / Gesamte Fassadenfläche × 100',
        },
        buildingEnvelope: {
          bra: 'Beheizte Nutzfläche (m²)',
          floors: 'Anzahl der Geschosse',
          floorHeight: 'Geschosshöhe (m)',
          indoorTemperature: 'Innentemperatur (°C)',
          heatedVolume: 'Beheiztes Luftvolumen (m³)',
          heatedVolumeFormula: 'Beheizte Nutzfläche × Geschosshöhe',
          thermalBridge: 'Wärmebrücke',
          thermalBridgeFormula: 'Beheizte Fläche × Normwert × Kelvin',
          totalExternalWallArea: 'Gesamtfläche der Außenwände',
          totalExternalWallAreaFormula: 'Summe aller Außenwandflächen',
          thermalBridgeCoefficient: 'Wärmebrückenkoeffizient (W/mK)',
          extwWallConstruction: 'Art der Außenwandkonstruktion',
          groundConditions: {
            title: 'Bodenverhältnisse',
            options: {
              none: 'Keine',
              clay: 'Ton',
              drySandGravel: 'Sand/Kies (trocken)',
              moistSandGravel: 'Sand/Kies (feucht)',
              wetSandGravel: 'Sand/Kies (nass)',
              rock: 'Fels',
              moraine: 'Moräne',
              dryPeat: 'Torf (trocken)',
              moistPeat: 'Torf (feucht)',
              wetPeat: 'Torf (nass)',
              silt: 'Schluff',
              organicSoil: 'Organischer Boden',
            },
            heatCapacity: 'Wärmekapazität (J/m²K)',
            thermalConductivity: 'Wärmeleitfähigkeit (W/mK)',
            groundTemperature: 'Bodentemperatur (°C)',
          },
          grossArea: 'Bruttofläche (m²)',
          netArea: 'Nettogrundfläche (m²)',
          netAreaFormula: 'Wandfläche − Fenster − Türen − Tore',
          wallConstruction: {
            title: 'Wandkonstruktion',
          },
          uValue: 'U-Wert (W/m²K)',
          shadingFactor: 'Verschattungsfaktor',
          area: 'Fläche (m²)',
          yearInstalled: 'Baujahr / Installationsjahr',
          yearInstalledNone: 'Keine Angabe',
          yearInstalledBefore1949: 'Vor 1949',
          yearInstalledFrom1997: 'Ab 1997',
          floor: {
            area: 'Fußbodenfläche (m²)',
            uValue: 'Fußboden U-Wert (W/m²K)',
            title: 'Fußboden',
            options: {
              title: 'Art des Bodenaufbaus',
              standard: 'Standard',
              tiles: 'Fliesen (7 mm) + Beton',
              flooringChipBoard: 'Belag (4 mm) + 22 mm Spanplatte',
              flooringConcrete: 'Belag (4 mm) + Beton',
              flooringLWA: 'Belag (4 mm) + Leichtbetondecke',
              parquetChipBoard: 'Parkett (14 mm) + 22 mm Spanplatte',
              parquetConcrete: 'Parkett (14 mm) + Beton',
              parquetLWA: 'Parkett (14 mm) + Leichtbetondecke',
              carpetChipBoard: 'Teppich (10 mm) + 22 mm Spanplatte',
              carpetConcrete: 'Teppich (10 mm) + Beton',
              carpetLWA: 'Teppich (10 mm) + Leichtbetondecke',
            },
          },
          roof: {
            title: 'Dach',
            optionsTitle: 'Dachkonstruktion',
            area: 'Dachfläche (m²)',
            uValue: 'Dach U-Wert (W/m²K)',
            options: [
              'Standard',
              'Kompaktdach mit 200–250 mm Beton, 200 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 250 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 300 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 350 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 400 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 450 mm Dämmung',
              'Kompaktdach mit 200–250 mm Beton, 500 mm Dämmung',
              'Kompaktdach mit Trapezblech, 200 mm Dämmung',
              'Kompaktdach mit Trapezblech, 250 mm Dämmung',
              'Kompaktdach mit Trapezblech, 300 mm Dämmung',
              'Kompaktdach mit Trapezblech, 350 mm Dämmung',
              'Kompaktdach mit Trapezblech, 400 mm Dämmung',
              'Kompaktdach mit Trapezblech, 450 mm Dämmung',
              'Kompaktdach mit Trapezblech, 500 mm Dämmung',
              'Satteldach mit 48 mm Sparren (9 % Flächenanteil), 200 mm Dämmung',
              'Satteldach mit 48 mm Sparren (9 % Flächenanteil), 250 mm Dämmung',
              'Satteldach mit 48 mm Sparren (9 % Flächenanteil), 300 mm Dämmung',
              'Satteldach mit 48 mm Sparren (9 % Flächenanteil), 350 mm Dämmung',
              'Satteldach mit 48 mm Sparren (9 % Flächenanteil), 400 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 200 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 250 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 300 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 350 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 400 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 450 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 500 mm Dämmung',
              'Satteldach mit I-Profil-Sparren (6 % Flächenanteil), 550 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 200 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 250 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 300 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 350 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 400 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 450 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 500 mm Dämmung',
              'Dach mit kaltem Dachraum, 48 mm Balken (9 % Flächenanteil), 550 mm Dämmung',
            ],
          },
          basement: {
            title: 'Keller',
            area: 'Kellerwandfläche (m²)',
            wallHeight: 'Wandhöhe (m)',
            wallThickness: 'Wanddicke (m)',
            baseWallConstruction: 'Wandkonstruktion',
            wallUValue: 'U-Wert (W/m²K)',
            heatStorage: 'Art der Wärmespeicherung',
            effectiveHeatCapacity: 'Effektive Wärmekapazität (kJ/m²K)',
            floorConstruction: 'Bodenkonstruktion',
            baseWallConstructionType: 'Typ der Wandkonstruktion',
            baseWallConstructionOptions: [
              'Standard',
              '200 mm Beton mit 100 mm Dämmung',
              '200 mm Beton mit 150 mm Dämmung',
              '200 mm Beton mit 200 mm Dämmung',
              '200 mm Beton mit 250 mm Dämmung',
              '200 mm Beton mit 300 mm Dämmung',
              '300 mm Beton mit 100 mm Dämmung',
              '300 mm Beton mit 150 mm Dämmung',
              '300 mm Beton mit 200 mm Dämmung',
              '300 mm Beton mit 250 mm Dämmung',
              '300 mm Beton mit 300 mm Dämmung',
            ],
            heatStorageTypes: [
              'Keine',
              'Leicht (< 50 Wh/m²K)',
              'Mittel (50–100 Wh/m²K)',
              'Schwer (100–150 Wh/m²K)',
              'Sehr schwer (> 150 Wh/m²K)',
              '100 mm Beton',
              '150 mm Beton',
              '200 mm Beton',
              '250 mm Beton',
              '300 mm Beton',
              'Holz',
              'Gipskarton',
            ],
            floorConstructionTypes: [
              'Keine',
              'Standard',
              'Bodenplatte auf Erdreich mit 100 mm Dämmung',
              'Bodenplatte auf Erdreich mit 150 mm Dämmung',
              'Bodenplatte auf Erdreich mit 200 mm Dämmung',
              'Bodenplatte auf Erdreich mit 250 mm Dämmung',
              'Bodenplatte auf Erdreich mit 300 mm Dämmung',
              'Bodenplatte auf Erdreich mit 350 mm Dämmung',
              'Bodenplatte auf Erdreich mit 400 mm Dämmung',
              'Holzbalkendecke mit 200 mm Dämmung',
              'Holzbalkendecke mit 250 mm Dämmung',
              'Holzbalkendecke mit 300 mm Dämmung',
            ],
          },
        },
        doors: {
          title: 'Türtyp',
          yearInstalled: 'Installationsjahr',
          totalArea: 'Gesamttürfläche',
          totalAreaFormula: 'Summe aller Türflächen',
          avgUValue: 'Mittlerer U-Wert (Türen)',
          avgUValueFormula: '(Σ(U × Fläche)) / Σ(Fläche)',
          percentageOfFacade: 'Türfläche in % der Fassade',
          percentageOfFacadeFormula:
            'Gesamttürfläche / Gesamte Fassadenfläche × 100',
          doorTypes: [
            'Keine',
            'Standard',
            'Isoliert',
            'Normal',
            'Gut isoliert',
            'Unisoliert',
          ],
        },
        gates: {
          title: 'Tortyp',
          yearInstalled: 'Installationsjahr',
          totalArea: 'Gesamttorfläche',
          totalAreaFormula: 'Summe aller Torflächen',
          avgUValue: 'Mittlerer U-Wert (Tore)',
          avgUValueFormula: '(Σ(U × Fläche)) / Σ(Fläche)',
          percentageOfFacade: 'Torfläche in % der Fassade',
          percentageOfFacadeFormula:
            'Gesamttorfläche / Gesamte Fassadenfläche × 100',
        },
        airLeakage: {
          airLeakageRate: 'Luftleckage (l/s·m² bei 50 Pa)',
          airChangeRate: 'Luftwechselrate (ACH bei 50 Pa)',
          naturalVentilation: 'Natürliche Lüftung',
        },
        thermalMass: {
          buildingHeatCapacity: 'Gesamte Wärmekapazität des Gebäudes',
          heatCapacitySelectTitle: 'Gebäudetyp (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Leichte Decke, dünner Bodenbelag, leichte Wände',
          shortDescriptionSecondOption:
            'Akustikdecke, Teppich auf Beton, leichte Wände',
          shortDescriptionThirdOption:
            'Geringer Anteil sichtbarer Beton (20 %), Parkett auf Beton',
          shortDescriptionFourthOption: 'Überwiegend sichtbarer Beton (70 %)',
          shortDescriptionFifthOption: 'Sichtbeton in Decke, Wänden und Boden',
          labelFirstOption: 'Sehr leichtes Gebäude',
          labelSecondOption: 'Leichtes Gebäude',
          labelThirdOption: 'Mittel-schweres Gebäude',
          labelFourthOption: 'Schweres Gebäude',
          labelFifthOption: 'Sehr schweres Gebäude',
          normalizedHeatCapacity: 'Normalisierte Wärmekapazität [Wh/(m²·K)]',
          normalizedHeatCapacityHelper:
            'Nach NS 3031 Tabelle B.8 – Wird in dynamischen Energieberechnungen verwendet',
          interiorWalls: 'Innenwände',
          north: 'Nord',
          south: 'Süd',
          east: 'Ost',
          west: 'West',
          claddingTitle: 'Verkleidungstyp',
          cladding: [
            'Benutzerdefiniert',
            'Standard',
            'Beton 100 mm (oder mehr)',
            'Beton 80 mm',
            'Porenbeton',
            'Gipskarton 13 mm',
            'Leichtziegel',
            'Leichtklinkerbeton',
            'Massivholz (Dicke über 40 mm)',
            'Holzverkleidung 15 mm',
            'Schwerer Vollziegel',
          ],
          claddingSubText: 'Benutzerdefiniert',
          internalConstruction: 'Innenkonstruktion',
          heatCapacity: 'Wärmekapazität [Wh/m²K]',
          grade: 'Klasse',
          furniture: {
            title: 'Möbel',
            options: ['Keine', 'Standard', 'Leicht', 'Mittel', 'Schwer'],
          },
          thermalHeatCapacityLabel: 'Thermische Speicherkapazität',
          thermalHeatCapacityFormula:
            'Beheizte Nutzfläche × Normwert / 1000 (Norm: Keine = 0, Leicht = 40, Mittel = 60, Schwer = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Fläche der Geschossdecken (m²)',
          internalFloorsTooltip:
            'Innere Geschossdecken zwischen Ebenen: beheizte Nutzfläche × (Anzahl Geschosse − 1) / Anzahl Geschosse',
        },
      },
    },
    report: {
      noReportYetTitle: 'Noch kein Bericht',
      noReportYetDescription:
        'Erstellen Sie einen ersten Berichtsentwurf, um mit der Dokumentation der Inspektion zu beginnen.',
      noReportYetSubDescription:
        'Der Bericht enthält Kapitel, Textfelder und Anhänge in einem strukturierten Format.',
      creatingDraft: 'Entwurf wird erstellt…',
      createDraft: 'Entwurf erstellen',

      title: 'Bericht',
      reportGenerationHint1:
        'Um den Bericht zu generieren, muss der Status der Inspektion auf abgeschlossen gesetzt werden.',
      reportGenerationHint2: 'Berichte werden alle fünfzehn Minuten generiert.',
      reportGenerationHint3:
        'Daten werden aus der Inspektion abgerufen, wenn der Status auf abgeschlossen gesetzt ist.',

      statusDraft: 'Entwurf',
      statusAiGenerate: 'AI-Generierung',
      statusComplete: 'Abgeschlossen',

      reportGenerationTitle: 'Berichtsgenerierung',
      reportGenerationLine1:
        'Um den Bericht zu generieren, muss der Status der Inspektion auf abgeschlossen gesetzt werden. Berichte werden alle fünfzehn Minuten generiert.',
      reportGenerationLine2:
        'Daten werden aus der Inspektion abgerufen, wenn der Status auf abgeschlossen gesetzt ist.',

      tableOfContents: 'Inhaltsverzeichnis',

      olderVersionWarning:
        'Warnung! Sie sehen eine ältere Version dieses Berichts.',

      saving: 'Speichern…',
      saveReport: 'Bericht speichern',
      deleteReport: 'Bericht löschen',

      confirmDeletionTitle: 'Löschen bestätigen',
      confirmDeleteReportMessage:
        'Möchten Sie diesen Bericht wirklich löschen?',
      confirmDeleteTextFieldMessage:
        'Möchten Sie dieses Textfeld wirklich löschen?',

      addField: 'Feld hinzufügen',
      fieldSingular: 'Feld',
      fieldsPlural: 'Felder',

      aiPrompt: 'AI-Prompt',
      reportText: 'Berichtstext',
      attachments: 'Anhänge',
      addImage: 'Bild hinzufügen',

      aiLabel: 'AI',
      scoreLabel: 'Punktzahl',

      versionLabel: 'Version',

      exportToWord: 'Nach Word exportieren',
      exportingWord: 'Exportieren...',
      wordExportProgress: {
        starting: 'Export wird gestartet...',
        capturingCharts: 'Diagramme erfassen...',
        capturingDetails: 'Berechnungsdetails erfassen...',
        buildingDocument: 'Dokument erstellen...',
        savingFile: 'Datei speichern...',
        complete: 'Export abgeschlossen',
        error: 'Export fehlgeschlagen. Bitte erneut versuchen.',
      },
    },
    UserCalendar: {
      createYourActivity: 'Erstelle deine Aktivität',
      categoryErrorMessage: 'Kategorie fehlt',
      titleErrorMessage: 'Titel fehlt',
      createActivity: 'Aktivität erstellen',
      editActivity: 'Aktivität bearbeiten',
      confirmDeletion: 'Löschen bestätigen',
      deleteMessage:
        'Bist du sicher, dass du diese Aktivität löschen möchtest?',
    },
  },
  attachments: {
    notes: 'Notizen',
    description: 'Beschreibung',
    replaceImage: 'Bild ersetzen',
    removeAttachment: 'Anhang entfernen',
    addImage: 'Bild hinzufügen',
    tags: 'Themen',
    uploadImage: 'Screenshot hochladen',
  },
  buildingControlProfile: {
    inOperationTitle: 'In Betrieb',
    outsideOperationTitle: 'Außer Betrieb',
    temperatureLower: 'Untere Temperaturgrenze (°C)',
    temperatureUpper: 'Obere Temperaturgrenze (°C)',
    humidityLower: 'Untere Feuchtigkeitsgrenze (%)',
    humidityUpper: 'Obere Feuchtigkeitsgrenze (%)',
    co2Tooltip: 'Maximal zulässiger CO₂-Wert, gemessen in ppm.',
    refreshInterval: 'Aktualisierungsintervall',
    refreshIntervalHelp: 'Wie oft der ASPA diese Einstellungen überprüft.',
    comfortWeight: 'Komfortgewichtung',
    energy: 'Energie',
    comfort: 'Komfort',
    costInfo:
      'Der Optimierer wägt Energieverbrauch und Komfort gegeneinander ab. Eine niedrige Komfortgewichtung priorisiert geringen Energieverbrauch, während eine hohe Komfortgewichtung besseren Komfort priorisiert. Beide Werte werden auf einer Skala von 0 bis 1 berechnet.',
  },
  gridRegions: {
    label: 'Stromzone',
    placeholder: '- Gebiet wählen -',
    groups: {
      nordic: 'Nordische Länder',
      centralEurope: 'Mitteleuropa',
      southernEurope: 'Südeuropa',
      baltic: 'Baltische Staaten',
      britishIsles: 'Britische Inseln',
      easternEurope: 'Osteuropa',
    },
    areas: {
      NO1: 'Oslo / Ostnorwegen',
      NO2: 'Kristiansand / Südnorwegen',
      NO3: 'Trondheim / Mittelnorwegen',
      NO4: 'Tromsø / Nordnorwegen',
      NO5: 'Bergen / Westnorwegen',
      SE1: 'Nordschweden',
      SE2: 'Mittleres Nordschweden',
      SE3: 'Mittelschweden',
      SE4: 'Südschweden',
      DK1: 'Westdänemark (Jütland-Fünen)',
      DK2: 'Ostdänemark (Seeland)',
      FI: 'Finnland',
      DE_LU: 'Deutschland-Luxemburg',
      AT: 'Österreich',
      BE: 'Belgien',
      NL: 'Niederlande',
      FR: 'Frankreich',
      CH: 'Schweiz',
      CZ: 'Tschechien',
      PL: 'Polen',
      SK: 'Slowakei',
      HU: 'Ungarn',
      SI: 'Slowenien',
      HR: 'Kroatien',
      IT_NORTH: 'Italien Nord',
      IT_CNORTH: 'Italien Mitte-Nord',
      IT_CSOUTH: 'Italien Mitte-Süd',
      IT_SOUTH: 'Italien Süd',
      IT_SICILY: 'Italien Sizilien',
      IT_SARDINIA: 'Italien Sardinien',
      ES: 'Spanien',
      PT: 'Portugal',
      GR: 'Griechenland',
      EE: 'Estland',
      LV: 'Lettland',
      LT: 'Litauen',
      GB: 'Großbritannien',
      IE_SEM: 'Irland (SEM)',
      RO: 'Rumänien',
      BG: 'Bulgarien',
      RS: 'Serbien',
      ME: 'Montenegro',
      AL: 'Albanien',
      MK: 'Nordmazedonien',
      BA: 'Bosnien und Herzegowina',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Nach Adresse suchen',
    placeholder: 'Straße, Nummer und Ort',
    moreHint:
      'Zeigt {shown} von {total}. Ort oder Postleitzahl ergänzen, um die Suche einzugrenzen.',
    noHitsHint:
      'Keine Treffer. Hausnummer und Ort ergänzen, zum Beispiel Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Energieausweis',
    language: 'Sprache',
    themeLight: 'Zu hellem Design wechseln',
    themeDark: 'Zu dunklem Design wechseln',
    title: 'Energielabel',
    loggedInAs: 'Angemeldet als',
    logout: 'Abmelden',
    login: {
      title: 'Anmelden',
      phoneDescription:
        'Melden Sie sich mit der Telefonnummer an, die Sie bei der Anforderung des Energieausweises (Energiattest) verwendet haben. Ein Bestätigungscode wird per SMS gesendet.',
      codeDescription: 'Geben Sie den sechsstelligen Code aus der SMS ein.',
      phone: 'Telefonnummer',
      phonePlaceholder: '1512 3456789',
      countryCode: 'Ländervorwahl',
      phoneHint: 'Die Nummer, die Sie bei der Anforderung angegeben haben.',
      code: 'Bestätigungscode',
      codeHint: 'Sechs Ziffern aus der SMS.',
      codeSentTo: 'Code gesendet an',
      sendCode: 'Code senden',
      verify: 'Bestätigen',
      changePhone: 'Andere Telefonnummer verwenden',
    },
    flow: {
      navTitle: 'So gehen Sie vor',
      draftSavedAt: 'Ihr Entwurf — zuletzt gespeichert',
      continueLater: 'Sie können schließen und später fortfahren.',
      draft: 'Entwurf',
      saveAndClose: 'Speichern und schließen',
      autosaved: 'Ihre Antworten werden automatisch gespeichert.',
      submitted: {
        title: 'Gesendet',
        body: 'Danke. Ein Energieberater prüft Ihre Angaben.',
      },
      back: 'Zurück',
      next: 'Weiter',
      submit: 'Einreichen',
      stepsMenu: 'Schritte',
      whyWeAsk: 'Warum fragen wir?',
      validation: {
        range: 'Muss zwischen {min} und {max} liegen.',
        min: 'Muss mindestens {min} sein.',
        max: 'Darf höchstens {max} sein.',
        positive: 'Muss über null liegen.',
      },
      select: 'Auswählen',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'Gebäudenr.',
      building: {
        address: 'Adresse',
        buildingNumber: 'Gebäudenr.',
        cadastre: 'Gnr / bnr',
        buildingType: 'Gebäudetyp',
        usableArea: 'Nutzfläche (BRA)',
        footprint: 'Grundfläche',
      },
      cadastre: {
        notFound:
          'Das Gebäude wurde im Kataster nicht gefunden. Tragen Sie ein, was Sie wissen.',
      },
      yesNo: { yes: 'Ja', no: 'Nein', dontKnow: 'Weiß nicht' },
      status: {
        completed: 'Abgeschlossen',
        defaults: 'Standardwerte',
        notApplicable: 'Nicht zutreffend',
      },
      steps: {
        confirmBuilding: {
          nav: 'Gebäude bestätigen',
          title: 'Gebäude bestätigen',
          eyebrow: 'Gefunden über GPS und das Liegenschaftskataster',
          question: 'Ist das Ihr Gebäude?',
          body: 'Wir haben das Gebäude markiert, das Ihrer Position am nächsten liegt. Prüfen Sie, ob Adresse und Gebäudenummer stimmen, bevor Sie fortfahren.',
          wrongHint:
            'Stimmt nicht? Tippen Sie auf das richtige Gebäude in der Karte oder suchen Sie nach der Adresse.',
          searchAddress: 'Nach Adresse suchen',
          mapTitle: 'Gebäudeauswahl',
          noBuilding:
            'Hier wurde kein Gebäude gefunden. Ziehen Sie die Markierung näher an das Gebäude.',
        },
        aboutBuilding: {
          nav: 'Über das Gebäude',
          title: 'Über das Gebäude',
          lead: 'Das meiste unten stammt aus dem Liegenschaftskataster. Korrigieren Sie, was nicht stimmt — der Ausweis baut auf diesen Zahlen auf.',
          aside: {
            title: 'Kategorie, Baujahr und Fläche',
            body: 'Gebäudekategorie, Baujahr und Nutzfläche sind die Grundlage der gesamten Berechnung. Die Kategorie bestimmt die Standardwerte, das Baujahr sagt, welche Bauvorschriften galten, und die Fläche entscheidet, wie viel Energie das Gebäude pro Quadratmeter verbraucht.',
          },
          sections: {
            category: {
              title: 'Gebäudekategorie',
              description:
                'Die Kategorie bestimmt, welche Standardwerte später verwendet werden.',
            },
            area: {
              title: 'Fläche und Höhe',
              description:
                'Die Grundfläche kann auch aus der Karte abgelesen werden.',
            },
          },
          fields: {
            category: {
              label: 'Kategorie',
              hint: 'Aus dem Kataster übernommen, wenn das Gebäude dort geführt ist.',
            },
            subcategory: {
              label: 'Unterkategorie',
              hint: 'Aus dem Kataster übernommen, wenn das Gebäude dort geführt ist.',
            },
            buildYear: {
              label: 'Baujahr',
              hint: 'Das Jahr des Baubeginns, falls bekannt.',
            },
            floors: {
              label: 'Anzahl Stockwerke',
              hint: 'Oberirdisch. Das Untergeschoss wird später ergänzt.',
            },
            footprint: {
              label: 'Grundfläche',
              hint: 'Aus dem Kataster oder der Karte.',
            },
            usableArea: {
              label: 'Gesamte Nutzfläche (BRA)',
              hint: 'Gesamte Geschossfläche aller Etagen, innerhalb der Außenwände gemessen.',
            },
            heatedArea: {
              label: 'Beheizte Nutzfläche',
              hint: 'Die Fläche, die auf über 15 °C beheizt wird.',
            },
            floorHeight: {
              label: 'Durchschnittliche Geschosshöhe',
              hint: 'Leer lassen, falls unbekannt, dann gilt der Standardwert der Kategorie.',
            },
          },
          options: {
            categories: {
              kontor: 'Bürogebäude',
              lettIndustri: 'Leichtindustrie',
              lager: 'Lagergebäude',
              forretning: 'Geschäftsgebäude',
              skole: 'Schulgebäude',
              hotell: 'Hotelgebäude',
            },
            subcategories: {
              lettindustriLager: 'Leichtindustrie und Lager',
              verksted: 'Werkstatt',
              produksjon: 'Produktionshalle',
            },
          },
          knowMore: 'Wissen Sie mehr über die Flächen?',
        },
        envelope: {
          nav: 'Gebäudehülle',
          title: 'Gebäudehülle',
          lead: 'Wie die Außenwände gebaut sind, bestimmt, wie viel Wärme das Gebäude verliert. Wählen Sie, was am ehesten passt.',
          sections: {
            walls: {
              title: 'Außenwände',
              description:
                'Material und Dicke bestimmen, wie viel Wärme die Wände nach außen lassen.',
            },
            more: {
              title: 'Was hat das Gebäude sonst noch?',
              description:
                'Was Sie hier ankreuzen, öffnet eigene Schritte im Menü.',
            },
          },
          fields: {
            construction: {
              label: 'Konstruktion',
              hint: 'Der häufigste Typ, wenn es mehrere gibt.',
            },
            insulation: {
              label: 'Dämmstärke',
              hint: 'Leer lassen, wenn Sie es nicht wissen — wir verwenden den Standard des Baujahrs.',
            },
          },
          options: {
            walls: {
              tre: 'Holz',
              mur: 'Mauerwerk',
              staal: 'Stahl',
              betong: 'Beton',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Keller oder Untergeschoss' },
            knowWindows: { label: 'Fenster' },
            doors: { label: 'Türen' },
            gates: { label: 'Tore' },
          },
          aside: {
            title: 'Wände und Wärmeverlust',
            body: 'Ein großer Teil der Wärme eines Gebäudes entweicht über die Wände. Material und Dämmung zeigen dem Berater, wie gut das Gebäude die Wärme hält. Wählen Sie, was am ehesten passt, den Rest berechnet der Berater.',
          },
        },
        basement: {
          nav: 'Keller',
          title: 'Keller',
          lead: 'Das Untergeschoss wird anders berechnet, weil es an das Erdreich und nicht an die Außenluft grenzt.',
          aside: {
            title: 'Keller zum Erdreich',
            body: 'Ein Keller grenzt an das Erdreich, nicht an die Außenluft. Das Erdreich hält über das Jahr eine gleichmäßigere Temperatur, daher wird der Wärmeverlust anders berechnet als bei Wänden über dem Boden. Ob der Keller beheizt ist, entscheidet, ob er zur beheizten Fläche zählt. Tragen Sie ein, was Sie wissen, leere Felder erhalten Standardwerte.',
          },
          section: {
            title: 'Das Untergeschoss',
            description:
              'Nur was Sie wissen. Leere Felder erhalten Standardwerte.',
          },
          checks: {
            heated: {
              label: 'Das Untergeschoss ist beheizt',
              description:
                'Ein unbeheizter Keller gilt als Puffer zum Erdreich.',
            },
          },
          fields: {
            floorArea: { label: 'Bodenfläche Keller' },
            wallLength: { label: 'Länge der Außenwände' },
            floorHeight: { label: 'Geschosshöhe' },
            wallThickness: { label: 'Kellerwanddicke' },
            depth: {
              label: 'Durchschnittliche Tiefe unter Geländeniveau',
              hint: 'Wie tief der Keller im Gelände liegt.',
            },
          },
          knowMore: 'Wissen Sie mehr über den Keller?',
        },
        windows: {
          nav: 'Fenster',
          title: 'Fenster',
          lead: 'Fenster machen einen großen Teil des Wärmeverlusts aus — und der Sonnenwärme. Die Verteilung nach Himmelsrichtung zählt am meisten.',
          sections: { area: { title: 'Die Fenster des Gebäudes' } },
          checks: {
            even: {
              label: 'Alle Fenster sind gleichmäßig über das Gebäude verteilt',
              description:
                'Wir teilen die Gesamtfläche gleichmäßig auf vier Fassaden auf.',
            },
          },
          fields: {
            windowType: {
              label: 'Fenstertyp',
              hint: 'Der häufigste Typ, wenn es mehrere gibt.',
            },
            totalArea: { label: 'Gesamte Fensterfläche' },
            installYear: {
              label: 'Einbaujahr Fenster',
              hint: 'Das Jahr, in dem die neuesten Fenster eingebaut wurden.',
            },
            north: { label: 'Nord' },
            east: { label: 'Ost' },
            south: { label: 'Süd' },
            west: { label: 'West' },
          },
          aside: {
            title: 'Himmelsrichtung',
            body: 'Fenster nach Süden lassen am meisten Sonnenwärme herein und senken den Heizbedarf. Nach Norden gibt es fast nur Wärmeverlust. Deshalb fragen wir je Fassade.',
          },
          knowMore: 'Wissen Sie mehr über die Fenster?',
        },
        doors: {
          nav: 'Türen und Tore',
          title: 'Türen und Tore',
          lead: 'Türen und Tore sind Teil der Gebäudehülle, und der Typ sagt viel über den Wärmeverlust aus. Tragen Sie ein, was Sie wissen oder woran Sie sich erinnern, der Rest erhält Standardwerte.',
          only: {
            doors: {
              nav: 'Türen',
              title: 'Türen',
              lead: 'Die Außentüren sind Teil der Gebäudehülle, und der Typ sagt viel über den Wärmeverlust aus. Tragen Sie ein, was Sie wissen oder woran Sie sich erinnern, der Rest erhält Standardwerte.',
              aside: {
                title: 'Türen und Wärmeverlust',
                body: 'Eine Außentür lässt mehr Wärme entweichen als die Wand darum. Der Türtyp sagt dem Berater ungefähr, wie gut sie dämmt. Was Sie nicht wissen, berechnet der Berater aus dem Baujahr und Standardwerten.',
              },
            },
            gates: {
              nav: 'Tore',
              title: 'Tore',
              lead: 'Tore sind oft die größten Öffnungen in der Gebäudehülle, und der Typ sagt viel über den Wärmeverlust aus. Tragen Sie ein, was Sie wissen oder woran Sie sich erinnern, der Rest erhält Standardwerte.',
              aside: {
                title: 'Tore und Wärmeverlust',
                body: 'Tore sind oft die größten Öffnungen im Gebäude und stehen häufig zeitweise offen. Der Tortyp sagt dem Berater ungefähr, wie gut sie dämmen. Was Sie nicht wissen, berechnet der Berater aus dem Baujahr und Standardwerten.',
              },
            },
          },
          aside: {
            title: 'Türen, Tore und Wärmeverlust',
            body: 'Türen und Tore lassen mehr Wärme entweichen als die Wand darum, und Tore stehen häufig zeitweise offen. Der Typ sagt dem Berater ungefähr, wie gut sie dämmen. Was Sie nicht wissen, berechnet der Berater aus dem Baujahr und Standardwerten.',
          },
          sections: {
            doors: { title: 'Türen', description: 'Außentüren für Personen.' },
            gates: {
              title: 'Tore',
              description: 'Einfahrtstore, Ladetore und Ähnliches.',
            },
          },
          fields: {
            doorType: {
              label: 'Türtyp',
              hint: 'Der häufigste Typ, wenn es mehrere gibt.',
            },
            installYear: { label: 'Einbaujahr' },
            uValue: {
              label: 'U-Wert, Durchschnitt',
              hint: 'Leer lassen, wenn Sie es nicht wissen.',
            },
            gateType: {
              label: 'Tortyp',
              hint: 'Der häufigste Typ, wenn es mehrere gibt.',
            },
            area: { label: 'Fläche' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Stahltür',
              glass: 'Glastür',
              tre: 'Holztür',
              aluminium: 'Aluminiumtür',
            },
            gateTypes: {
              leddportIsolert: 'Gedämmtes Sektionaltor',
              leddport: 'Ungedämmtes Sektionaltor',
              rulleport: 'Rolltor',
              hurtigport: 'Schnelllauftor',
            },
          },
          knowMoreDoors: 'Wissen Sie mehr über die Türen?',
          knowMoreGates: 'Wissen Sie mehr über die Tore?',
        },
        energySources: {
          nav: 'Energiequellen',
          title: 'Energiequellen',
          lead: 'Welche Energiequellen hat das Gebäude? Die Auswahl hier öffnet die nächsten Schritte.',
          sections: {
            delivered: {
              title: 'Gelieferte Energie',
              description:
                'Kreuzen Sie alles an, was an das Gebäude angeschlossen ist.',
            },
            own: { title: 'Eigene Erzeugung' },
          },
          checks: {
            electricity: {
              label: 'Strom',
              description:
                'Alle Gebäude haben Strom. Nur Strom ergibt eine vereinfachte Berechnung.',
            },
            districtHeating: {
              label: 'Fernwärme',
              description: 'Öffnet den Schritt Zentralheizungsanlage.',
            },
            heatPump: {
              label: 'Wärmepumpe',
              description: 'Öffnet den Schritt Wärmepumpe.',
            },
            fossil: {
              label: 'Öl, Gas oder Bio',
              description: 'Öffnet den Schritt Heizkessel.',
            },
            other: {
              label: 'Andere Energiequellen',
              description:
                'Beschreiben Sie diese im Kommentarfeld im letzten Schritt.',
            },
            solar: {
              label: 'Das Gebäude hat eine Photovoltaikanlage',
              description: 'Öffnet den Schritt Solaranlage.',
            },
          },
          aside: {
            title: 'Zentralheizung',
            body: 'Fernwärme, Wärmepumpe und Kessel können alle an eine Zentralheizungsanlage angeschlossen sein. Im nächsten Schritt fragen wir, wie sie sich Heizung und Warmwasser teilen.',
          },
        },
        centralHeating: {
          nav: 'Zentralheizungsanlage',
          title: 'Zentralheizungsanlage',
          lead: 'Gewählte Energiequellen — so sind sie in der Zentralheizungsanlage eingerichtet.',
          sections: {
            plant: { title: 'Die Anlage' },
            districtHeating: {
              title: 'Fernwärme',
              description: 'So wird die Fernwärme im Gebäude genutzt.',
            },
          },
          fields: {
            location: {
              label: 'Standort',
              hint: 'Wo sich die Heizzentrale befindet.',
            },
            installYear: { label: 'Einbaujahr' },
            connectedTo: {
              label: 'Angeschlossen an',
              hint: 'Wohin das Wasser fließt.',
            },
          },
          options: {
            locations: {
              tekniskRom: 'Technikraum',
              kjeller: 'Keller',
              tak: 'Dach',
              egetBygg: 'Eigenes Gebäude',
            },
            connections: {
              oppvarming: 'Heizung',
              oppvarmingVent: 'Heizung und Lüftung',
            },
          },
          checks: {
            forHeating: { label: 'Raumheizung' },
            forHotWater: { label: 'Warmwasser' },
          },
          aside: {
            title: 'Die Wärme wird von der Zentrale verteilt',
            body: 'Die Zentralheizung bringt die Wärme der Energiequellen als Wasser ins Gebäude. Wo die Zentrale steht und ob das Wasser auch die Lüftungsluft erwärmt, entscheidet, wie viel Wärme unterwegs verloren geht. Fehlen Ihnen die Angaben, verwenden wir Standardwerte.',
          },
        },
        heatPump: {
          nav: 'Wärmepumpe',
          title: 'Wärmepumpe',
          lead: 'Typ und Leistung der Wärmepumpe. Leistung und Verbrauch stehen meist auf dem Typenschild oder im Serviceheft.',
          sections: {
            plant: { title: 'Die Anlage' },
            connection: { title: 'Anschluss' },
          },
          fields: {
            type: { label: 'Typ' },
            installYear: { label: 'Einbaujahr' },
            power: {
              label: 'Leistung',
              hint: 'Nennwärmeleistung vom Typenschild.',
            },
            annualUse: {
              label: 'Jahresverbrauch',
              hint: 'Vom Stromzähler oder der Steuerung, falls vorhanden.',
            },
          },
          options: {
            types: {
              luftLuft: 'Luft–Luft',
              luftVann: 'Luft–Wasser',
              vaeskeVann: 'Sole–Wasser',
              avtrekk: 'Abluftwärmepumpe',
            },
          },
          checks: {
            connected: {
              label:
                'Die Wärmepumpe ist an die Zentralheizungsanlage angeschlossen',
              description:
                'Der Anteil wird im Schritt Heizung und Kühlung festgelegt.',
            },
          },
          knowMore: 'Wissen Sie mehr über die Wärmepumpe?',
          aside: {
            title: 'Mehr Wärme als Strom',
            body: 'Eine Wärmepumpe gewinnt Wärme aus Luft, Wasser oder Erdreich und liefert mehr Kilowattstunden Wärme, als sie an Strom verbraucht. Typ, Leistung und Alter bestimmen ihre Effizienz, und das fließt direkt in die Energieklasse ein. Fehlen Ihnen die Zahlen, verwenden wir Standardwerte.',
          },
        },
        boiler: {
          nav: 'Heizkessel',
          title: 'Heizkessel',
          lead: 'Der Kessel, der mit Öl, Gas oder Biomasse befeuert wird. Die Leistung steht meist auf dem Typenschild.',
          sections: { plant: { title: 'Der Kessel' } },
          fields: {
            fuelType: { label: 'Kesseltyp' },
            power: {
              label: 'Leistung bei Volllast',
              hint: 'Vom Typenschild oder aus den Unterlagen.',
            },
          },
          options: {
            fuelTypes: { olje: 'Öl', gass: 'Gas', bio: 'Biomasse' },
          },
          aside: {
            title: 'Brennstoff zählt unterschiedlich',
            body: 'Öl, Gas und Biomasse werden im Energieausweis unterschiedlich gewichtet, daher beeinflusst der Kesseltyp sowohl die Energieklasse als auch die Heizungsnote. Die Leistung zeigt, welchen Anteil des Wärmebedarfs der Kessel decken kann. Fehlen Ihnen die Zahlen, verwenden wir Standardwerte.',
          },
        },
        solar: {
          nav: 'Solaranlage',
          title: 'Solaranlage',
          lead: 'Selbst erzeugter Strom wird im Ausweis von der gelieferten Energie abgezogen.',
          sections: {
            plant: {
              title: 'Die Photovoltaikanlage',
              description:
                'Die Zahlen stehen meist in den Unterlagen des Installateurs oder in der App der Anlage.',
            },
            hotWater: { title: 'Warmwasser' },
          },
          fields: {
            installedPower: {
              label: 'Installierte Leistung',
              hint: 'Steht in der Anlagendokumentation.',
            },
            installYear: { label: 'Einbaujahr' },
            annualProduction: {
              label: 'Jahresproduktion',
              hint: 'Vom Wechselrichter oder aus der App der Anlage.',
            },
            panelArea: { label: 'Modulfläche' },
          },
          checks: {
            hotWaterConnected: {
              label: 'Warmwasser ist an die Zentralanlage angeschlossen',
              description:
                'Siehe Energiequellen. Sonst gilt Warmwasser als elektrisch.',
            },
          },
          aside: {
            title: 'Eigener Strom zählt positiv',
            body: 'Der Strom der Solaranlage deckt einen Teil des Verbrauchs des Gebäudes, und das kann ein besseres Energielabel ergeben. Deshalb müssen wir wissen, wie groß die Anlage ist. Fehlen Ihnen die Zahlen, schreiben Sie das im letzten Schritt ins Kommentarfeld.',
          },
          knowMore: 'Wissen Sie mehr über die Solaranlage?',
        },
        ventilation: {
          nav: 'Lüftung',
          systemTitle: 'Anlage {number}',
          title: 'Lüftung',
          lead: 'Hat das Gebäude eine Lüftungsanlage?',
          sections: {
            type: {
              title: 'Lüftungsanlage',
              description:
                'Nur eine Zu- und Abluftanlage braucht weitere Angaben.',
            },
            plant: {
              title: 'Die Anlage',
              description:
                'Ein Gerät bläst frische Luft ein und zieht verbrauchte Luft ab, oft mit Wärmerückgewinnung.',
            },
            capacity: {
              title: 'Kapazität — je Anlage',
              description:
                'Ist die Kapazität größer als der Mindestwert, muss sie angegeben werden.',
            },
            maintenance: { title: 'Wartung' },
          },
          fields: {
            hasSystems: { label: 'Hat das Gebäude eine Lüftungsanlage?' },
            count: {
              label: 'Anzahl Anlagen',
              hint: 'Sie erhalten einen Feldsatz pro Anlage.',
            },
            type: { label: 'Typ' },
            installYear: { label: 'Einbaujahr' },
            airflowOperating: { label: 'Luftmenge während der Betriebszeit' },
            airflowOff: { label: 'Luftmenge außerhalb der Betriebszeit' },
            lastMaintenance: {
              label: 'Letztes Wartungsdatum',
              hint: 'Aus dem Servicebericht.',
            },
            regularMaintenance: { label: 'Regelmäßige Wartung der Anlage?' },
            moreInfo: {
              label:
                'Haben Sie weitere Informationen zur Lüftung für den Berater?',
              hint: 'Filterwechsel, Betriebszeiten, bekannte Abweichungen.',
            },
            heatRecovery: {
              label: 'Wärmerückgewinnungsgrad',
              hint: 'Aus der Dokumentation des Geräts.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label: 'Fortluftwärmepumpe an die Zentrale angeschlossen',
            },
            extractHeatPump: {
              label: 'Abluftwärmepumpe an die Zentrale angeschlossen',
            },
          },
          options: {
            types: {
              avtrekk: 'Mechanische Abluft',
              balansert: 'Zu- und Abluftanlage',
            },
            typeDescriptions: {
              avtrekk:
                'Große Teile des Gebäudes haben eine mechanische Abluft.',
            },
          },
          aside: {
            title: 'Luft und Wärme',
            body: 'Die Lüftung tauscht verbrauchte Innenluft gegen frische Außenluft. Eine Anlage, die die Wärme aus der Abluft zurückgewinnt, spart viel Energie. Fehlen Ihnen die Zahlen, verwenden wir Standardwerte.',
          },
          knowMore: 'Wissen Sie mehr über die Lüftung?',
        },
        heating: {
          nav: 'Heizung und Kühlung',
          title: 'Heizung und Kühlung',
          lead: 'Die Vorschläge unten basieren auf den gewählten Energiequellen und der Lüftung. Tragen Sie den Anteil ein, den jede Lösung abdeckt, wenn Sie ihn kennen.',
          groups: {
            electric: { title: 'Elektrische Heizung' },
            central: { title: 'Zentralheizung' },
          },
          options: {
            electric: {
              panelHeaters: 'Heizpaneele',
              convectors: 'Konvektoren',
              electricBoiler: 'Elektrokessel mit Warmwasserspeicher',
              electricFloor: 'Fußbodenheizung',
              ventilationHeat: 'Luftheizung über Lüftung',
              airToAir: 'Wärmepumpe Luft–Luft',
            },
            central: {
              radiators: 'Heizkörper',
              convectors: 'Konvektoren',
              waterFloor: 'Fußbodenheizung',
              ventilationHeat: 'Luftheizung über Lüftung',
            },
          },
          sections: { cooling: { title: 'Kühlung' } },
          checks: {
            hasCooling: {
              label: 'Das Gebäude hat Kühlung',
              description:
                'Kältemaschine, Fernkälte oder Wärmepumpe im Kühlbetrieb.',
            },
          },
          aside: {
            title: 'Tragen Sie ein, was Sie wissen',
            body: 'Wenn Sie es nicht wissen, müssen Sie die Felder nicht ausfüllen. Tragen Sie ein, was Sie wissen, worüber Sie etwas wissen, oder ungefähre Werte. Mehr Details geben dem Energieberater eine bessere Grundlage.',
          },
          singleShare: 'Wir nehmen an, dass diese die gesamte Heizung abdeckt.',
        },
        summary: {
          nav: 'Zusammenfassung und Einreichung',
          title: 'Zusammenfassung und Einreichung',
          lead: 'Der Energieausweis wird genauer — und oft besser — je mehr Felder ausgefüllt sind.',
          alert: {
            title: '{count} Schritte verwenden Standardwerte',
            body: 'Eine unvollständige Datengrundlage bedeutet, dass die Energiebewertung mit begrenzten Informationen erfolgt. Teile der technischen Anlagen und des Gebäudes werden dann nach Standardwerten berechnet. Sie können jetzt einreichen oder zurückgehen und mehr ausfüllen, für ein genaueres Label.',
          },
          registered: 'Ihre Angaben',
          confirmFirst:
            'Bestätigen Sie vor dem Absenden, dass die Angaben nach bestem Wissen gemacht wurden.',
          sections: { advisor: { title: 'An den Berater' } },
          fields: {
            note: {
              label:
                'Gibt es etwas, das der Berater über Energiefluss und Verbrauch wissen sollte?',
              hint: 'Zum Beispiel: Teile des Gebäudes stehen leer, Nacht- und Wochenendabsenkung, kürzliche Austausche, bekannte Leckagen.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'Alle Angaben wurden nach bestem Wissen und in gutem Glauben gemacht',
              description:
                'Der Berater nutzt Ihre Antworten als Grundlage für den Energieausweis. Sie können später korrigieren, wenn etwas falsch war.',
            },
          },
          aside: {
            eyebrow: 'Wie geht es weiter?',
            title: 'Ihre Angaben gehen an den Berater',
            body: 'Ein Energieberater prüft Ihre Antworten und sendet den Energieausweis an Enova. Niemand muss das Gebäude besuchen. Sie werden benachrichtigt, wenn der Ausweis fertig ist.',
          },
        },
      },
      knowInstallYear: 'Kennen Sie das Installationsjahr?',
      assumeBuildYear: 'Wir nehmen an, dass es aus {year} stammt.',
      buildYearWord: 'dem Baujahr',
      assumeStandard: 'Wir nehmen Standardwerte an.',
    },
  },
};

export default GERMAN;
